export const wishesMock = [
    {
        "Отметка времени": "12\/25\/2023 10:21:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Александра Максимова ",
        "wish": "Спасибо за поддержку во всем, позитивный настрой и готовность помочь в любых, даже в самых экстраординарных вопросах! :) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:22:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "ФЭУ",
        "wish": "За самую чуткую и внимательную работу и готовность всегда помочь во всех вопросах, связанных с вашей зоной ответственности! Спасибо! "
    },
    {
        "Отметка времени": "12\/25\/2023 10:23:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Тамерлан Надвидов ",
        "wish": "За оперативную помощь с заявками в 1С и готовность помочь по всем вопросам! :) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:28:29",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.cherepanova@ampm-world.com",
        "to": "Александр Шацкий",
        "wish": "Хочу выразить благодарность за терпение и понимание в решении наших непростых задач!"
    },
    {
        "Отметка времени": "12\/25\/2023 10:31:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.cherepanova@ampm-world.com",
        "to": "Татьяна Астахова",
        "wish": "Мои сердечные приветы и благодарности за тёплую атмосферу и слаженную работу в создании креативных упаковок!"
    },
    {
        "Отметка времени": "12\/25\/2023 10:34:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru",
        "to": "Мария Калинина",
        "wish": "Спасибо Маше за ее инициативность и участие в контроле обеспечения Казахстана. Тепла, уюта и добра в новом году "
    },
    {
        "Отметка времени": "12\/25\/2023 10:34:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "liliya.lebed@aquaart.ru",
        "to": "Управление информационных технологий",
        "wish": "Хочу выразить огромную благодарность управлению информационных технологий за совместную продуктивную работу в 2023!  Вы сделали рабочий процесс гораздо эффективнее!   Спасибо, что поддерживали мои идеи и начинания! Особо хочу выделить - систему оповещения по приходу товара в 1С! А также доработку отчета по ПДЗ! Спасибо всем, кто помогал настроить и сделать отчеты идеальными! И всем, кто на протяжении года помогает нам решать вопросы по 1С: Дмитрий Заречнюк, Валерия Колесниченко,  Михаил Калугин, Яна Небывалова  - спасибо ❤ Благодаря вам мы становимся лучше)  Пусть в 2024 году  у вас будет много новых свершений, успешных проектов и прекрасное настроение каждый день!"
    },
    {
        "Отметка времени": "12\/25\/2023 10:35:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Екатерине Ермаковой",
        "wish": "Екатерина, выражаю большую благодарность за Ваш труд и поддержку! Вы прекрасный руководитель, который всегда может найти крутое и быстрое решение в любой ситуации. Спасибо за вашу поддержку и профессионализм! "
    },
    {
        "Отметка времени": "12\/25\/2023 10:37:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.Lebed@aquaart.ru",
        "to": "Служба клиентского сервиса",
        "wish": "Спасибо всем координаторам, кто шел на встречу и делился  своими резервами для горящих отгрузок ❤"
    },
    {
        "Отметка времени": "12\/25\/2023 10:38:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Команда подбора Акваарт",
        "wish": "Дорогие коллеги из команды подбора, большое спасибо за вашу работу, вы сделали нереальные результаты за последние несколько месяцев, сильно выросли в своем профессионализме, я очень вами горжусь и желаю и далее самых крутых офферов и звездных кандидатов!"
    },
    {
        "Отметка времени": "12\/25\/2023 10:41:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Служба управления товарными запасами",
        "wish": "Огромное спасибо всем за вклад в обеспечение всех новых рынков; за то, что постоянно держите руку на пульсе и решаете все сложные кроссфункциональные вопросы связанные с выходом на новые территории. Пусть новый год будет интересным и впереди ждут самые яркие впечатления! Успехов, достижения всех поставленных целей, больше позитива и чтобы было время и поработать и отдохнуть ! ) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:43:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Петрова Эля ",
        "wish": "Эля спасибо, что откликаешься моментально на любой запрос  и за великолепно подготовленные отчеты! Пусть новый год откроет двери к новым свершениям! ) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:43:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.lebed@aquaart.ru",
        "to": "Татьяна Чернышова",
        "wish": "Огромное спасибо Татьяне за помощь в самых сложных вопросах в любое время суток)  Решить проблему со сверкой ключевого клиента  в пятницу в 21.30  - это мощно!  Спасибо за крутые лайфхаки по работе в 1С! Теперь часть супер силы есть и у меня :)   Желаю самого лучшего настроения и много путешествий в 2024 м!) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:48:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Михайлова Ольга",
        "wish": "Оля спасибо за позитивный подход к любой задаче, за инициативность и неординарный подход. В новом году желаю достижения всех целей и пусть вдохновение не покидает! ) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:48:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Павел Азовский и УТК",
        "wish": "Павел Анатольевич, благодарю за продуктивное сотрудничество, быстрое реагирование на все вопросы и всегда позитивный заряд от Вас! Вы мотивируете и вдохновляете на активную работу и всегда заряжаете! Пусть и в следующем году этот заряд будет таким же ярким, как все подразделение УТК в котором работают замечательные люди!!!"
    },
    {
        "Отметка времени": "12\/25\/2023 10:53:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.Lebed@aquaart.ru",
        "to": "УТК: Бренд Damixa ",
        "wish": "Спасибо Ксении и Юлии за классные и крутые продукты, которые мы увидели в этом году! Надеюсь в 2024-м у нас будет еще много интересных новинок от вас)  Пусть у вас всегда будет лучшее качество, классные цены и  конечно улыбка на лице)  С вами всегда приятно общаться, и я очень ценю вашу оперативность и помощь в поиске товара по объемным проектным заказам! Спасибо!) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:53:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Федор Полкунов",
        "wish": "Федор, благодарю за крутое сотрудничество, отличное настроение, вдохновение и мотивацию на работу! "
    },
    {
        "Отметка времени": "12\/25\/2023 10:53:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.Lebed@aquaart.ru",
        "to": "Шунков Сергей",
        "wish": "Спасибо за живые видео продуктов и классные распаковки!) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:56:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru",
        "to": "Велькина Евгения ",
        "wish": "Женя, спасибо за целеустремленность, за все проекты, которые были реализованы в уходящем году, за полное понимание важности и значимости нашего дела. Очень приятно иметь в команде такого ответственно и инициативного человека. Пусть новый год принесет больше творческих и интересных проектов. Успеха и развития ! ) "
    },
    {
        "Отметка времени": "12\/25\/2023 10:57:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Николай Плотник",
        "wish": "Николай, спасибо тебе за всегда быструю обратную связь, помощь в работе, чудесное настроение и бодрый заряд! Работать с тобой одно удовольствие! Пусть в следующем году сбываются все желания, результаты набирают легендарных высот и будет душевный баланс!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:00:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.Lebed@aquaart.ru",
        "to": "Дарина Подковыркина ",
        "wish": "Спасибо Дарине за еженедельные отчеты ИММ, которые помогают нам лучше отрабатывать продажи на территории и следить за динамикой ❤ Дарина всегда на оперативной связи и помогает нашим клиентам чувствовать заботу и поддержку, ведь их проблемы с бонусами всегда быстро решаются!  Пусть в 2024-м будет меньше обращений в поддержку,  и много интересных задач)  Спасибо за Gif-ки в  чате поддержки - ты задаешь нам настроение) "
    },
    {
        "Отметка времени": "12\/25\/2023 11:05:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Станислав Гуров",
        "wish": "Стас, благодарю за сотрудничество! Пусть в новом году будет много радостей, крутых проектов, шикарных результатов, отличный настрой и душевное спокойствие! Обнимаю!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:08:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.Shunkov@aquaart.group",
        "to": "Управление персоналом",
        "wish": "Вы лучшая команда - настоящий дрим тим! Поддержка, внимание, а главное - крутые проекты которые мы делаем вместе! Я рад быть частью нашей компании - вместе нам всё по плечу)"
    },
    {
        "Отметка времени": "12\/25\/2023 11:10:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.Shunkov@aquaart.group",
        "to": "Управление Товарными Категориями",
        "wish": "Коллеги - это настоящий прорыв! Новые смесители, ванны, супер крутая душевая программа. Я вижу как появляется новая, супер крутая керамика, радует новинками мебель для ванной комнаты. И конечно аксессуары - коллекция Func - это моя любовь)"
    },
    {
        "Отметка времени": "12\/25\/2023 11:12:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.Shunkov@aquaart.group",
        "to": "УД",
        "wish": "Друзья! Это фантастика. Знаю, что каждый раз мы покоряем всё большие и большие вершины. И приступая к очередному вызову - вы решительны и бескомпромиссны! Так держать! Вы супер драйверы компании. Наша гордость! Лучшие в отрасли! "
    },
    {
        "Отметка времени": "12\/25\/2023 11:12:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Ирина Ледянкина ",
        "wish": "Я благодарна Ирине за внедрение КЭДО. С ним действительно стало проще, быстрее и удобнее обмениваться документами с сотрудниками"
    },
    {
        "Отметка времени": "12\/25\/2023 11:13:46",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Анна Хазанова",
        "wish": "Аня, спасибо тебе за прекрасную работу, такую крутую организацию праздников и корпоративах мероприятий, подарков для нас! Твой труд очень ценен! Пусть в следующем году будет очень много вдохновения, идей и открытий! Мы тебя всегда поддержим! Обнимаю!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:17:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.Shunkov@aquaart.group",
        "to": "Служба сервиса (Спб)",
        "wish": "Когда я плотно работал в продажах - для меня было абсолютно ясно, что только благодаря крепкой поддержки сервиса возможно достижение сверх результатов. Коллеги из Сервисного центра - вы Боги поддержки и понимания. Ваше внимание, терпение и огромный профессиональный опыт - подобного просто нет в отрасли! А тот креатив с коротым вы подходите в решении нестандартных задач - настоящая фантастика - иногда, кажется, что вы, как команда - способны творить чудеса. Хотя это так и есть! Вы лучшие. Спасибо!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:40:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalya.Ivanova@aquaart.ru",
        "to": "Координаторы СРП",
        "wish": "Дорогие девчата! Спасибо Вам за ваш упорный, не легкий труд! Огромное спасибо за поддержку, отзывчивость и Ваши милые улыбки!!! Желаю всего самого доброго в Новом году! Пусть сбываются все Ваши мечты!!!!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:42:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalya.Ivanova@aquaart.ru",
        "to": "Горячев Алексей",
        "wish": "Самый крутой руководитель!!! Опора, руководство, теплое слово - это все наш Леша!!!! Спасибо большое!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:51:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "ФЭУ",
        "wish": "Спасибо большое за поддержку в начале моей работы в Акваарт и за то, что вы каждый день помогаете добиваться результатов, открывать новые счета для компаний Группы и соответственно открывать новые горизонты для бизнеса компании!"
    },
    {
        "Отметка времени": "12\/25\/2023 11:53:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Радмила Покраяц",
        "wish": "Спасибо, самый солнечный и отзывчивый сотрудник юридической службы, которого я когда либо встречала за свою 25-летнюю карьеру в финансах!  "
    },
    {
        "Отметка времени": "12\/25\/2023 14:07:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.koroleva@aquaart.ru",
        "to": " СКЛАД Черкизово ",
        "wish": "Вам, коллеги, Благодарность\n Шлю от сердца, от души. \nВедь соратники по делу \nЧудо, как уж хороши.\nЗа поддержку в час нелегкий \nИ авралов мега дни. \nНикогда не отказали, \nНе оставили в дали.\nВам желаю я успехов,\n Дружно в коллективе жить. \nЧтоб любые Вас проблемы \nНе заставили тужить."
    },
    {
        "Отметка времени": "12\/25\/2023 15:25:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "daria.klimova@aquaart.ru",
        "to": "Войцеховская Мария",
        "wish": "Достаточно быстро влилась в работу) Желаю процветания, счастья, успехов во всем :-) "
    },
    {
        "Отметка времени": "12\/25\/2023 15:28:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "daria.klimova@aquaart.ru",
        "to": "ФЭУ МСК",
        "wish": "Сплоченность коллектива) Желаю успехов во всем, счастья, здоровья и всего самого наилучшего))"
    },
    {
        "Отметка времени": "12\/25\/2023 15:33:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "maria.voitsekhovskaya@aquaart.ru",
        "to": "Дарья Климова",
        "wish": "Дашенька, хочу сказать спасибо за твою помощь, поддержку, доброту и отзывчивость!!!!Ты прекрасный человек и отличный специалист!!!!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:41:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "lerichaava@aqaart.ru",
        "to": "Поспелов Игорь",
        "wish": "План отгрузок каждого месяца в 2023 году был перевыполнен."
    },
    {
        "Отметка времени": "12\/25\/2023 16:42:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "karina.pachina@aquaart.ru",
        "to": "Алёна Кучеренко",
        "wish": "Спасибо за четкую организацию премьеры Func!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:43:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "Ирина Ледянкина",
        "wish": "Ирина ввела КЭДО. Желаю чтобы все мечты сбывались!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:45:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "lerichaava@aquaart.ru",
        "to": "Магомедов Магомед",
        "wish": "Быстрое эффективное решение сложных вопросов"
    },
    {
        "Отметка времени": "12\/25\/2023 16:46:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "Анна Хазанова",
        "wish": "Анна организовала крутые праздники и подарки. Желаю еще больше креативных идей и крутых проектов!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:49:35",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "Сергей Шунков",
        "wish": "Сергей организовал проведение обучения на платформе Webinar. Желаю быть успешным и всегда достигать намеченных целей!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:50:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "karina.pachina@aquaart.ru",
        "to": "Виталий Курган",
        "wish": "Спасибо за эффективное управление все большим количеством территорий и всегда приятное и качественное взаимодействие"
    },
    {
        "Отметка времени": "12\/25\/2023 16:52:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.zalesskaia@aquaart.ru",
        "to": "Екатерина Пименова",
        "wish": "Спасибо за креатив и самый красивый контент в отрасли!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:52:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.mironyuk@aquaart.ru",
        "to": "Игорь Поспелов",
        "wish": "За максимум вовлечения в работу с Леруа (СПБ) Самая высокая доля среди всех региональных компаний! Браво!"
    },
    {
        "Отметка времени": "12\/25\/2023 16:53:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.zalesskaia@aquaart.ru",
        "to": "Егор Ксенафонтов",
        "wish": "Спасибо за отзывчивость и всегда хорошее настроение :)"
    },
    {
        "Отметка времени": "12\/25\/2023 16:54:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Кристина Коньшакова",
        "wish": "Хочется сказать спасибо за вовлеченность и ответственность в решениях задач"
    },
    {
        "Отметка времени": "12\/25\/2023 16:54:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "daniil.lukovitsky@aquaart.ru",
        "to": "Мария Каменская и Кристина Коньшакова",
        "wish": "Ответственность, отзывчивость, работоспособность и профессиональный подход к каждому клиенту этих двух замечательных операционистов равен как минимум 50% моего результата."
    },
    {
        "Отметка времени": "12\/25\/2023 16:55:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Лери Чаава",
        "wish": "Хочется сказать спасибо за обучение подходу решения задач "
    },
    {
        "Отметка времени": "12\/25\/2023 16:56:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "leri.chaava@aquaart.ru",
        "to": "Вадим Гончарук",
        "wish": "Ведение нескольких проектов с успех во всех. "
    },
    {
        "Отметка времени": "12\/25\/2023 16:59:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Павел Миронюк",
        "wish": "За быструю обратную связь, которая помогала в решениях задач"
    },
    {
        "Отметка времени": "12\/25\/2023 17:00:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "Екатерина Ермакова",
        "wish": "Благодаря Екатерине в УП реализовано много креативных и крутых проектов. Желаю чтобы все мечты и планы осуществились! Пусть успех и процветание всегда сопутствуют в работе и жизни!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:00:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Ольга Терехова",
        "wish": "За помощь во всех возникающих вопросах, настоящий командный игрок"
    },
    {
        "Отметка времени": "12\/25\/2023 17:01:46",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Даниил Луковицкий",
        "wish": "За позитивную атмосферу в офисе "
    },
    {
        "Отметка времени": "12\/25\/2023 17:04:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "karina.pachina@aquaart.ru",
        "to": "Фёдор Полкунов",
        "wish": "Спасибо за прекрасное представление нашего бренда на конференции Яндекс"
    },
    {
        "Отметка времени": "12\/25\/2023 17:09:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "Igor.pospelov@aquaart.ru",
        "to": "Анна Кузина",
        "wish": "За молниеносную скорость ответа на все запросы"
    },
    {
        "Отметка времени": "12\/25\/2023 17:11:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "Екатерина Яндолина",
        "wish": "Екатерина - профессионал своего дела. Желаю чтобы Новый год принес не только новый бесценный опыт, но и - еще больше сбывшихся желаний!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:26:28",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.mironova@ampm-world.com",
        "to": "Управление персоналом",
        "wish": "Спасибо за профессионализм, внимание и поддержку!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:28:56",
        "Баллы": 0,
        "Ваша корпоративная почта": " radmila.pokraiats@aquaart.ru",
        "to": "Анна Минаева - ФЭУ (Бухгалтерия)",
        "wish": "За новый подход к работе, за трудолюбие, терпение и классно подобранную команду!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:29:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Ледянкина Ирина",
        "wish": "Внедрение электронного кадрового учета - это супер прорыв в автоматизации КДП 2023!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:31:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "Yuriy.Dzhavadov@aquaart.ru",
        "to": "Лошкарева Яна и Пименова Екатерина",
        "wish": "За поддержку и терпение, с которым вы выслушиваете мои запросы и идеи)"
    },
    {
        "Отметка времени": "12\/25\/2023 17:33:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Светлана Залесская ",
        "wish": "За самые креативные идеи, готовность всегда помочь, и полную поддержку в подготовке Дня Бренда! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:34:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Проектные продажи",
        "wish": "Спасибо за крутое развитие канала и новых перспективных клиентов! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:34:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Анна Хазанова",
        "wish": "Спасибо за разработку и успешный старт программы развития лидеров Акваарт \"Динамичный Менеджмент\""
    },
    {
        "Отметка времени": "12\/25\/2023 17:34:35",
        "Баллы": 0,
        "Ваша корпоративная почта": "Yuriy.Dzhavadov@aquaart.ru",
        "to": "Федору Полкунову ",
        "wish": "За большие свершения в Европе, теперь это точно \"Наш\" рынок сбыта"
    },
    {
        "Отметка времени": "12\/25\/2023 17:34:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Дмитрий Заречнюк ",
        "wish": "Спасибо за активное участие и поддержку программы Динамичный менеджмент! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:35:40",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Сергей Шунков ",
        "wish": "Спасибо за введение новой digital-платформы для организации обучения! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:35:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "Yuriy.Dzhavadov@aquaart.ru",
        "to": "Петровской Анне",
        "wish": "За выдающийся результат на маркетплейсах, и открыть к новым вершинам"
    },
    {
        "Отметка времени": "12\/25\/2023 17:37:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Татьяна Истомина",
        "wish": "Спасибо за готовность помочь во всем, невероятную чуткость и многозадачность! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:38:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Андрей Таскаев",
        "wish": "Спасибо за готовность передавать ценный опыт, за помощь в разработке программы развития лидеров Акваарт \"Динамичный менеджмент\", за успешный коучинг лидера программы Анны Хазановой."
    },
    {
        "Отметка времени": "12\/25\/2023 17:38:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "Lidiya.Bronnikova@aquaart.ru",
        "to": "Катерина Багрянова ",
        "wish": "За скорость обработки информации и принятия решений "
    },
    {
        "Отметка времени": "12\/25\/2023 17:38:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.frantsuzhan@aquaart.group",
        "to": "Анна Минаева",
        "wish": "Благодарю за чуткое руководство, профессиональные качества и приятную атмосферу в коллективе! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:39:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.mironova@ampm-world.com",
        "to": "Марина Мокроусова ",
        "wish": "Хочу пожелать оставаться такой же жизнерадостной зажигалочкой! Спасибо за поддержку)"
    },
    {
        "Отметка времени": "12\/25\/2023 17:39:58",
        "Баллы": 0,
        "Ваша корпоративная почта": "Lidiya.Bronnikova@aquaart.ru",
        "to": "Терзийски Наталья ",
        "wish": "Благодарность за позитив и стрессоустойчивость "
    },
    {
        "Отметка времени": "12\/25\/2023 17:41:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.makeeva@ampm-world.com",
        "to": "Всему прекрасному и любимому ФЭУ!",
        "wish": "Спасибо коллегам за неиссякаемый оптимизм и готовность поддержать в любых ситуациях!  Николаю отдельное спасибо за супер-терпение)"
    },
    {
        "Отметка времени": "12\/25\/2023 17:43:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.frantsuzhan@aquaart.group",
        "to": "ФЭУ.Бухгалтерия",
        "wish": "Спасибо всему коллективу за слаженную работу, поддержку, за ваши идеи, за ваше терпение и за ваш энтузиазм. Пусть каждый день приносит вам новые достижения и радостные моменты!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:43:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Дмитрий Заречнюк",
        "wish": "Спасибо за готовность участвовать в программе развития лидеров Акваарт Динамичный менеджмент несмотря на большую загрузку в текущей деятельности, за включенность, мудрость и профессионализм. Спасибо за четкую и слаженную работу команды ИТ, инновационный подход и классную реализацию проектов по автоматизации процессов УП в 2023 году."
    },
    {
        "Отметка времени": "12\/25\/2023 17:45:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.dimitrova@aquaart.ru",
        "to": "Синякова Вероника",
        "wish": " Спасибо большое Коллега!  Всегда придёт на помощь.Оперативно  и быстро решит любой вопрос."
    },
    {
        "Отметка времени": "12\/25\/2023 17:45:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "veronika.sinyakova@aquaart.ru",
        "to": "Ирина Лобкова ",
        "wish": "Спасибо, Ирине, нашему новому бухгалтеру! Она очень добрый человек и прекрасный сотрудник, который взял на себя большую часть работы и делает нашу команду еще сильнее и эффективнее "
    },
    {
        "Отметка времени": "12\/25\/2023 17:45:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "tamerlan.nadvidov@aquaart.group",
        "to": "Анна Минаева",
        "wish": "Спасибо большое за то что веришь в меня, за то что пытаешься поддержать в трудную минуту, учитываешь мнение каждого в коллективе и стараешься организовать работу внутри отдела с максимальной отдачей. Спасибо что ты всегда такая веселая, жизнерадостная, всегда подскажешь (когда не занята :D) совет и стараешься не расстраиваться из-за мелочей."
    },
    {
        "Отметка времени": "12\/25\/2023 17:46:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasia.daineko@ampm-world.com",
        "to": "Светлана Макеева (Носикова)",
        "wish": "Спасибо за помощь и поддержку"
    },
    {
        "Отметка времени": "12\/25\/2023 17:47:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.lobkova@aquaart.group",
        "to": "Мариночке Димитровой",
        "wish": "Спасибо за доброжелательность, за помощь в адаптации в новом коллективе=*"
    },
    {
        "Отметка времени": "12\/25\/2023 17:47:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasia.daineko@ampm-world.com",
        "to": "Гапон Елена",
        "wish": "Спасибо за помощь и поддержку"
    },
    {
        "Отметка времени": "12\/25\/2023 17:47:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Шунков Сергей",
        "wish": "Спасибо за классное настроение и драйв, за крутой заряд энергии для всех сотрудников компании! За реализацию проекта автоматизация курсов обучения на платформе вебинар! За классные встречи в формате MY Team!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:47:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.dimitrova@aquaart.ru",
        "to": "Минаева Анна",
        "wish": "Спасибо большое Анне за нашу такую классную команду!"
    },
    {
        "Отметка времени": "12\/25\/2023 17:48:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "veronika.sinyakova@aquaart.ru",
        "to": "Багрянова Екатерина ",
        "wish": "Спасибо Кате! Самому лучшему учителю, наставнику и просто очень классному человеку"
    },
    {
        "Отметка времени": "12\/25\/2023 17:49:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Екатерина Яндолина",
        "wish": "Спасибо за профессионализм и готовность поддержать команду всегда и во всем, за готовность осваивать новый функционал, за улыбку и тепло каждый день!\n"
    },
    {
        "Отметка времени": "12\/25\/2023 17:49:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "dmitry.saidov@aquaart.ru",
        "to": "Светлана Макеева, Карина Пачина, Светлана Горшкова, Александр Татищев.",
        "wish": "Год был насыщенный на эмоции и вызовы. Полученный опыт можно применять на                       всех этапах работы в компании. Произошло море положительных моментов и оглядываясь назад особенно хочется выделить несколько человек.\n\nСветлана Макеева.\n\nСветлана эксперт, высокий профессионал своего дела. Даже если кажется, что выхода нет, она помогает. Хочу сказать Светлане спасибо за ее открытость и скорость обработки запросов. Благодаря Светлане удалось воплотить множество проектов. Спасибо!!\n\nКарина Пачина. \n\nКуда же мы без маркетинга. Карина всегда поможет и подскажет, как эффективнее мотивировать клиента, как получить нужное количество посмов. Хочу сказать Спасибо Карина за твою отзывчивость, за то, что ты не боишься брать на себя дополнительные задачи и всегда доводишь все до конца.\n\nСветлана Горшкова.\n\nСветлана, Светлана. Спасибо тебе за то, что тебе не все равно. Светлана всегда выслушает и поддержит тебя в любой сложной ситуации. Всегда с улыбкой, всегда в отличном настроении. Спасибо за эмоциональный заряд.\n Александр Татищев.\n\nЗнания сила. Благодаря Александру за этот год я узнал множество вещей. Саша Клондайк идей и путей решений сложных моментов. Во времена упадка энергии. Саша Всегда поддержит, поможет и подарит заряд мотивации.\n"
    },
    {
        "Отметка времени": "12\/25\/2023 17:51:28",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Елена Кострикина",
        "wish": "Спасибо за лидерство в проектах УП \"Адаптация\", \"Пул Талантов\", за профессионализм и внедрение новых подходов работе по ОТ"
    },
    {
        "Отметка времени": "12\/25\/2023 17:54:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.bagryanova@aquaart.ru ",
        "to": "Радмила Покраяц",
        "wish": "Спасибо Радмиле за то, что она всегда находит интересных и одаренных сотрудников и отправляет их ко мне)"
    },
    {
        "Отметка времени": "12\/25\/2023 17:56:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "sgorshkova@aquaart.ru",
        "to": "Яне Фомичевой",
        "wish": "Яна! спасибо от всего сердца за твой профессионализм, желание разобраться в любом вопросе и за то, что ты всегда готова помочь! Спасибо за мои отпуска! \n"
    },
    {
        "Отметка времени": "12\/25\/2023 17:57:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "veronika.sinyakova@aquaart.ru",
        "to": "Димитрова Марина ",
        "wish": "Спасибо Марише! За доброту, за профессионализм, за то, что она прекрасный человек! "
    },
    {
        "Отметка времени": "12\/25\/2023 17:59:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "sgorshkova@aquaart.ru",
        "to": "Калугин Михаил",
        "wish": "Михаил! благодарю за терпение и за быстрое реагирование на запросы, спасибо, что помогаешь разобраться в любом вопросе! \n"
    },
    {
        "Отметка времени": "12\/25\/2023 17:59:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.pimenova@aquaart.ru",
        "to": "Юрий Джавадов ",
        "wish": "Благодарю Юрия Джавадова за то, что он является неиссякаемым источником идей"
    },
    {
        "Отметка времени": "12\/25\/2023 18:00:40",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.makeeva@ampm-world.com",
        "to": "Команды УД: СПб ФС, УК М ФС, Проекты, ЛР, Казахстан",
        "wish": "Спасибо коллегам за проявленное терпение и понимание) Желаю дальнейшего развития и роста продаж!"
    },
    {
        "Отметка времени": "12\/25\/2023 18:00:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "sgorshkova@aquaart.ru",
        "to": "Яне Небываловой",
        "wish": "Яна! благодарю за юмор! благодарю за легкость в решении вопросов! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:01:33",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.pimenova@aquaart.ru",
        "to": "Елена Кондратьева ",
        "wish": "Благодарю Лену за высочайший профессионализм "
    },
    {
        "Отметка времени": "12\/25\/2023 18:01:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "tamerlan.nadvidov@aquaart.group",
        "to": "Екатерина Багрянова ",
        "wish": "Спасибо тебе Катя за то что ты всегда такая жизнерадостная, яркий солнечный лучик. Ты научила меня многим вещам, которые мне пригодятся в будущем. Спасибо за хорошие воспоминания и хорошее время препровождение в офисе когда ты тут, благодаря тебе невозможно заскучать!!!) Спасибо что ты с нами и радуешь всех своей улыбкой)"
    },
    {
        "Отметка времени": "12\/25\/2023 18:10:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "Mikhail.Vasiliev@aquaart.ru",
        "to": "Егор Ксенафонтов",
        "wish": "Спасибо за быстроту решения вопросов и готовность помочь всегда и везде! :)"
    },
    {
        "Отметка времени": "12\/25\/2023 18:14:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "Mikhail.Vasiliev@aquaart.ru",
        "to": "Екатерина Пименова",
        "wish": "Спасибо за самый крутой контент на свете! :)"
    },
    {
        "Отметка времени": "12\/25\/2023 18:20:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "Sannikova <elvirElvira a.sannikova@aquaart.ru>",
        "to": "Нигматуллина Лиана",
        "wish": "Я хочу поблагодарить Лиану Н., за её отзывчивость, терпение, неиссякаемое желание улучшить рабочий процесс и любовь к компании!"
    },
    {
        "Отметка времени": "12\/25\/2023 18:24:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "Sannikova <elvirElvira a.sannikova@aquaart.ru>",
        "to": "Подразделение ФЭУ",
        "wish": "Вы все и каждый из Вас, крутые специалисты, добрые и отзывчивые люди! Работать бок о бок с Вами, одно удовольствие! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:31:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "Sannikova <elvirElvira a.sannikova@aquaart.ru>",
        "to": "Подразделение СРП ТК",
        "wish": "Ваша оперативность в решение поставленных перед вами задач, иногда обескураживает. Вы всегда заряжаете позитивом и на вас можно положиться))) Желаю Вам всем достижения личных и профессиональных высот!"
    },
    {
        "Отметка времени": "12\/25\/2023 18:34:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Сергей Сабуров",
        "wish": "Спасибо за крутое развитие ТК СПб и МСК и классный проект Aquaart Sports Community! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:35:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Лилия Лебедь ",
        "wish": "За крутые инициативы и идеи в Банк Идей! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:35:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Ирина Ледянкина и Екатерина Яндолина",
        "wish": "Спасибо за внедрение Кадрового Электронного Документооборота! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:36:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "vladislav.fediuntsov@aquaart.ru",
        "to": "Пачина Карина Анна Хазанова Евгения Велькина Юрий Быковский Виталий Курган",
        "wish": "Спасибо за крутой корпоратив! Лучший состав ведущих)"
    },
    {
        "Отметка времени": "12\/25\/2023 18:37:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Федор Полкунов ",
        "wish": "Спасибо за крутое руководство международными рынками и классное развитие продаж! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:38:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Вадим Гончарук",
        "wish": "За поддержку международных продаж и внимательность к деталям! "
    },
    {
        "Отметка времени": "12\/25\/2023 18:50:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "ПФО №1",
        "wish": "Спасибо - за результаты и успех в ведении клиентов и за супер крутую командную работу, продолжаем расти профессионально и получать новый опыт!"
    },
    {
        "Отметка времени": "12\/25\/2023 18:55:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "УФО",
        "wish": "Спасибо – за введение новых практик, амбициозный подход и космический рост в 2023! Успехов в следующем году, новых целей и новых высот!"
    },
    {
        "Отметка времени": "12\/25\/2023 19:00:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "Горячев Алексей",
        "wish": "Спасибо за поддержку и интересный опыт, который помог подняться на несколько уровней выше в профессиональном плане!"
    },
    {
        "Отметка времени": "12\/25\/2023 19:55:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Марина Мокроусова",
        "wish": "Спасибо за талант находить классных людей, за успехи в международном подборе, за ориентацию на результат, за солнечную улыбку и позитив!"
    },
    {
        "Отметка времени": "12\/25\/2023 19:57:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Анна Миронова",
        "wish": "Благодарю за быстрый старт, за рекордное закрытие вакансий с первого месяца работы!"
    },
    {
        "Отметка времени": "12\/25\/2023 19:59:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Виктория Войницкая",
        "wish": "Спасибо за профессиональный рост, за успехи в закрытие вакансий Москвы."
    },
    {
        "Отметка времени": "12\/25\/2023 20:04:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "ИТ",
        "wish": "Спасибо за  оперативность во взаимодействии при выходе новых сотрудников, за реализацию проектов по автоматизации процессов УП, за поддержку 24\/7. Вы классная и профессиональная команда!\n"
    },
    {
        "Отметка времени": "12\/26\/2023 2:13:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Виталий Курган ",
        "wish": "Спасибо за  невероятный рост у клиента Сантехлюкс на протяжении двух лет подряд! Спасибо за  самоотдачу и поиск новых  решений в нестандартных  ситуациях! Желаю  никогда не сдаваться и  доли двадцать  на Урале!"
    },
    {
        "Отметка времени": "12\/26\/2023 2:21:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Наталья Корнилова ",
        "wish": "Спасибо за  невероятную работоспособность  и упорство  в  достижении  поставленных целей! Спасибо за вечный девиз \"План есть для того чтобы его  перевыполнять\"! Желаю  много  новых  территорий в наступающем  году, ведь мы  точно  сделаем там  еще круче чем в Каисе!  "
    },
    {
        "Отметка времени": "12\/26\/2023 2:26:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Денис Перминов ",
        "wish": "Спасибо за отсутствие страха к новым вызовам! Спасибо за  побитые  рекорды! Желаю не останавливаться на достигнутом ведь все только начинается!  "
    },
    {
        "Отметка времени": "12\/26\/2023 2:31:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Сергей Кодулев ",
        "wish": "Спасибо за невероятную  скорость  в постановке новинок!  Спасибо  за  легкость в  решении  любых  вопросов ! Желаю  фееричного  роста  продаж  от  Камчатки  до  Владивостока в наступающем  году)"
    },
    {
        "Отметка времени": "12\/26\/2023 2:37:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Евгений Покровский ",
        "wish": "Спасибо за упорство в развитии новой  территории! Желаю  много  ярких побед в  наступающем 24 году"
    },
    {
        "Отметка времени": "12\/26\/2023 2:44:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "Aleksei.Goryachev@aquaart.ru",
        "to": "Денис Жидовкин",
        "wish": "Спасибо за  невероятную  самоотдачу и  работоспособность в  самом  объемном  канале  продаж! Спасибо  за  желание  бороться с  вызовами! Желаю  чтобы  персонал для  находился легко в  любой точке страны , а Краснодар и Омск  стали новыми мерилами  лучшей работы с залами!     "
    },
    {
        "Отметка времени": "12\/26\/2023 9:15:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "Anastasia.Pashevina@aquaart.ru",
        "to": "Всей Бухгалтерии",
        "wish": "Спасибо бухгалтерии за готовность помочь, за отзывчивость, оперативность и теплое отношение."
    },
    {
        "Отметка времени": "12\/26\/2023 9:16:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "Anastasia.Pashevina@aquaart.ru",
        "to": "Анне Лебедевой",
        "wish": "Спасибо за оперативность, готовность помочь в любом вопросе по 1С, оптимизм и хорошее настроение)) "
    },
    {
        "Отметка времени": "12\/26\/2023 9:17:54",
        "Баллы": 0,
        "Ваша корпоративная почта": "Anastasia.Pashevina@aquaart.ru",
        "to": "Радмиле Покраяц",
        "wish": "Спасибо этому светлому человечку за прекрасную атмосферу в кабинете, за юмор, оптимизм и балдежно вкусные палочки Милк :)"
    },
    {
        "Отметка времени": "12\/26\/2023 9:32:29",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.modestova@aquaart.ru",
        "to": "Екатерина Ермакова",
        "wish": "Ценные советы, касающиеся управления персоналом. Поддержке коллег и их мотивации."
    },
    {
        "Отметка времени": "12\/26\/2023 10:07:58",
        "Баллы": 0,
        "Ваша корпоративная почта": "Marina.Istratiy@ampm-world.com",
        "to": "УП",
        "wish": "Благодарю за поддержку и быстрое решение всех вопросов! С Новым Годом!"
    },
    {
        "Отметка времени": "12\/26\/2023 10:12:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Digital Office",
        "wish": "Спасибо за помощь во всех проектах и за диджитализацию Акваарта! Без вас не было бы этой чудесной digital-елки! Вы крутые, пусть 2024 год принесет еще больше вдохновения и ярких результатов! "
    },
    {
        "Отметка времени": "12\/26\/2023 10:34:28",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.ermakova@aquaart.ru",
        "to": "Светлана Залесская",
        "wish": "Спасибо за креативные идеи и помощь в организации Созвездия и корпоративных праздников, за идею дизайна и  реализацию проекта оформления  нового  Европейского офиса! "
    },
    {
        "Отметка времени": "12\/26\/2023 11:02:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.Shunkov@aquaart.group",
        "to": "Liana Shtembulyak",
        "wish": "Огромная благодарность Лиане. Спасибо тебе за это крутое обучение - блестящая работа! Это первое обучение подобного рода за всю историю компании!"
    },
    {
        "Отметка времени": "12\/26\/2023 11:06:33",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Саидов Дмитрий",
        "wish": "Спасибо тебе за твою вовлечённость и креатив! Ты потрясающий человек и очень крутой профессионал. Развивая территории, ты успеваешь находить энергию и время на развития своих коллег. Я благодарен тебе за обучение ТБП - это супер инструмент!"
    },
    {
        "Отметка времени": "12\/26\/2023 11:12:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Виталий Курган",
        "wish": "Ты просто супер звезда - даже выглядишь именно так) И поступаешь именно так! \nВсегда энергичный и решительный в работе настоящий профи, а в кругу друзей просто душа компании! Ты крут! Спасибо тебе! "
    },
    {
        "Отметка времени": "12\/26\/2023 11:12:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "daniil.lukovitsky@aquaart.ru",
        "to": "Сабуров Сергей",
        "wish": "Благодарность за профессионализм, трудовую преданность и отличные организационные навыки"
    },
    {
        "Отметка времени": "12\/26\/2023 11:14:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Покровский Евгений",
        "wish": "Евгений, я благодарен тебе за то внимание и вовлечённость, что ты проявляешь как в своей работе, так и в проектах компании. В этом году я успел с тобой повзаимодействовать в разных направлениях, это и адаптация нового сотрудника и обучения и конечно же - внутрикорпоративные проекты! Ты супер! Спасибо тебе! "
    },
    {
        "Отметка времени": "12\/26\/2023 11:15:21",
        "Баллы": 0,
        "Ваша корпоративная почта": "daniil.lukovitsky@aquaart.ru",
        "to": "Анна Кузина",
        "wish": "Благодарность за чуткость, высокую самоотдачу и выдержку"
    },
    {
        "Отметка времени": "12\/26\/2023 11:25:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Горячев Алексей",
        "wish": "Алексей, ты настоящий локомотив! Работая с тобой я всегда ощущаю, что могу намного больше! Ты пример пунктуальности и осведомлённости + ты так увлечён своим делом, что это просто заразительно) \n\nЯ рад, быть с тобой в одной команде и делать крутые и креативные проекты! \nСпасибо тебе! "
    },
    {
        "Отметка времени": "12\/26\/2023 11:27:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "daniil.lukovitsky@aquaart.ru",
        "to": "Инна Никитина",
        "wish": "Оперативность, отзывчивость и профессионализм"
    },
    {
        "Отметка времени": "12\/26\/2023 11:47:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Саша Шацкий, Егор Ксенафонтов, Артём Мишин",
        "wish": "Парни, большое спасибо за Rise, наш первый европейский международный сертификат!"
    },
    {
        "Отметка времени": "12\/26\/2023 11:56:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Калугин Михаил",
        "wish": "Спасибо Михаилу за знание 1С от пяточек до макушки и регулярную помощь в работе с ней "
    },
    {
        "Отметка времени": "12\/26\/2023 11:57:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Юля Леденёва",
        "wish": "Юля, спасибо за новые 60 торговых точек c Damixa в Традиционном канале РФ!"
    },
    {
        "Отметка времени": "12\/26\/2023 12:01:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Радмила Покраяц",
        "wish": "Спасибо Радмиле за подключение к вопросам сертификации. Спасибо за инициативность, оперативность и всегда хорошее настроение ) "
    },
    {
        "Отметка времени": "12\/26\/2023 12:05:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Елена Гапон",
        "wish": "Лена спасибо за профессионализм и четкость во всех вопросах! ) "
    },
    {
        "Отметка времени": "12\/26\/2023 12:12:29",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Алёна Кучеренко",
        "wish": "Алёна, спасибо за обстоятельную подготовку и ведение проекта по заведению Func & X-Joy! "
    },
    {
        "Отметка времени": "12\/26\/2023 12:17:21",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Величко Андрей",
        "wish": "Андрей, спасибо за обстоятельный и профессиональный подход к созданию продуктов в категории, за новые производственные площадки!"
    },
    {
        "Отметка времени": "12\/26\/2023 12:24:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Вадим и Вадим",
        "wish": "Вадим и Вадим, спасибо за ключевых клиентов на новом рынке, это супер достижение, вы крутые!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:46:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "elvira.abdurazakova@aquaart.ru",
        "to": "Сурикова Надежда",
        "wish": "За помощь и поддержку в любое время суток! "
    },
    {
        "Отметка времени": "12\/26\/2023 13:47:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.mikhailova@aquaart.ru",
        "to": "Михаил Калугин",
        "wish": "спасибо за оперативную и качественную поддержку"
    },
    {
        "Отметка времени": "12\/26\/2023 13:47:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.mikhailova@aquaart.ru",
        "to": "УТЗ",
        "wish": "Спасибо за обеспечение товаром!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:48:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "Anastasia.Smolnikova@aquaart.ru",
        "to": "Шоу-рум AmPm",
        "wish": "За нашу крутую работу и самый дружный и приятный коллектив! Юлиана, Витя, Анжей, Рома, спасибо вам! Самые лучшие)"
    },
    {
        "Отметка времени": "12\/26\/2023 13:49:54",
        "Баллы": 0,
        "Ваша корпоративная почта": "nadezhda.surikova@aquaart.ru",
        "to": "Павел Пивоваров ",
        "wish": "спасибо "
    },
    {
        "Отметка времени": "12\/26\/2023 13:54:07",
        "Баллы": 0,
        "Ваша корпоративная почта": " radmila.pokraiats@aquaart.ru",
        "to": "Наталья Мартынова ",
        "wish": "За активную позицию, работу в режиме многозадачности, отзывчивость и четкость!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:54:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "Radmila Pokraiats <radmila.pokraiats@aquaart.ru>",
        "to": "Анастасии Пашевиной",
        "wish": "За трудолюбие, ответственность, за неиссякаемый оптимизм и зарплату вовремя :D "
    },
    {
        "Отметка времени": "12\/26\/2023 13:55:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "Эльвира и Лиана",
        "wish": "Спасибо за командную работу, поддержку и помощь! Скорость и качество- это про ВАС!!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:56:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.revenko@aquaart.ru",
        "to": "Горячев Алексей",
        "wish": "Благодарю за профессионализм, креативный подход к работе, за помощь и внимательное отношение к коллективу!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:56:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Мироновой Анне",
        "wish": "Анна, очень рада, что ты в нашей команде. С тобой очень комфортно работать и общаться. Желаю тебе успехов в работе и отличного настроения)))"
    },
    {
        "Отметка времени": "12\/26\/2023 13:56:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "Radmila Pokraiats <radmila.pokraiats@aquaart.ru>",
        "to": "Эльвире Санниковой",
        "wish": "За крутейший человеческие качества, за стремление привнести новое и огромную проделанную работу по согласованию договоров :* "
    },
    {
        "Отметка времени": "12\/26\/2023 13:57:30",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "Смирнова Дарья",
        "wish": "Супер профессионал, скорость и оперативность, ответственное отношение и просто отличный человек - это все Даша! спасибо тебе!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 13:58:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "lidiya.bronnikova@aquaart.group",
        "to": "Анна Тропина ",
        "wish": "Спасибо, что оперативно и вовлечено решаешь все наши текущие вопросы, связанные с переездом в ЕРП:-) "
    },
    {
        "Отметка времени": "12\/26\/2023 13:58:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "Vitalii.Kurgan@aquaart.ru",
        "to": "Саидов Дима",
        "wish": "Спасибо за креатив и драйв, за новые идеи и проекты, за амбициозность и решительность! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:00:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "Radmila Pokraiats <radmila.pokraiats@aquaart.ru>",
        "to": "Лиане Нигматуллиной (Штембуляк)",
        "wish": "За профессионализм, за отзывчивость, за прекрасную улыбку и позитивный настрой!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:02:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "elvira.letfullina@aquaart.ru",
        "to": "Данилкина Марина",
        "wish": "Хочу высказать свою искреннюю благодарность и признательность за совместную работу, за ваш честный и продуктивный труд. Пускай каждый рабочий день и далее будет плодотворным, и приносит не только деньги, но и радость от проделанной работы!\n\n"
    },
    {
        "Отметка времени": "12\/26\/2023 14:04:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.chernyshova@aquaart.ru",
        "to": "Горячев Алексей",
        "wish": "Спасибо за все)Лучший руководитель, всегда помогает в рабочих процессах)Приятно работать с профессионалом)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:05:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "Tatyana.chernyshova@aquaart.ru",
        "to": "Эля и Лиана(ФэУ)",
        "wish": "Спасибо за поддержку, за оперативность)С Вами очень приятно работать)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:06:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "Tatyana.chernyshova@aquaart.ru",
        "to": "Лилия Лебедь",
        "wish": "Очень ответственный РМ, который многое делает для работы )Спасибо❤️"
    },
    {
        "Отметка времени": "12\/26\/2023 14:06:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "maria.kalinina@ampm-world.com",
        "to": "Логистика",
        "wish": "Друзья, вы большие молодцы! спасибо что вы привозите товары от любых поставщиков и доставляете их нашим клиентам в любые желаемые точки мира! Ни мировая нестабильность, ни зной, ни зимние морозы и снег не остановят вас для достижения целей!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:07:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "liliya.lebed@aquaart.ru",
        "to": "РМ СРП",
        "wish": "Хочу отметить РМ СРП - тех, кто ежедневно совершает подвиги на передовой продаж! Вы большие молодцы!  Ваши достижения  и рост отгрузок - впечатляют!  Новогоднего настроения и отличных продаж в 2024! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:09:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "Svetlana.borisova@aquuart.ru",
        "to": "Панкратова Анна",
        "wish": "За огромный профессионализм и помощь в сложных ситуациях. Лучший координатор!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:11:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.istomina@aquaart.ru",
        "to": "Радмила Покраяц",
        "wish": "Бести, спасибо за поддержку! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:11:46",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.istomina@aquaart.ru",
        "to": "Анна Хазанова",
        "wish": "Анечка, спасибо за поддержку и все то, что ты делаешь! Ты большая молодец! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:12:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.Istomina@aquaart.ru",
        "to": "Екатерина Багрянова",
        "wish": "Катя, спасибо тебе за помощь и поддержку! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:13:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Кострикиной Елене ",
        "wish": "Елена - профессионал в сфере охраны труда. Да и вообще супер-человек. Выполняет множество задач и проектов, не связанных с охраной труда. Имеет широкий кругозор, поэтому с Леной можно найти любую тему для разговора. Лена, спасибо, что ты с нами)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:13:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.ledyankina@aquaart.ru",
        "to": "Яндолиной Екатерине",
        "wish": "Катя - ты отличный специалист, на тебя всегда можно положиться, ты супер!! Желаю тебе успехов в карьере и счастья в личной жизни)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:13:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "Evgeny.pokrovsky@aquaart.ru",
        "to": "Команде РМ ПФО2, ЦФО и Алексею Горячеву",
        "wish": "Лучшая региональная команда менеджеров, которая не смотря на трудности этого года, добивается поставленных целей! И конечно Алексею Горячеву большое спасибо, за поддержку, помощь и наставничество, ты делаешь нас лучше, профессиональнее, успешнее!   С Наступающим друзья, всем здоровья и успеха!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:13:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.lipovaya@aquaart.ru",
        "to": "Яна Фомичева",
        "wish": "Яна, Спасибо огромное за Ваш вклад в нас! За  позитивный настрой, неутомимую энергию и душевность!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:14:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.istomina@aquaart.ru",
        "to": "Карина Пачина",
        "wish": "Карина, спасибо тебе за поддержку и помощь! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:14:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "Svetlana.borisova@aquaart.ru",
        "to": "Князева Валерия",
        "wish": "Лера, на тебя хочется равняться ! Спасибо за терпение и поддержку."
    },
    {
        "Отметка времени": "12\/26\/2023 14:16:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.ledyankina@aquaart.ru",
        "to": "Кострикина Лена",
        "wish": "Лена спасибо, что ты есть в УП!!) Ты помогаешь нам всем! Охрана труда в надежных руках!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:16:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.lipovaya@aquaart.ru",
        "to": "Светлана Осипова",
        "wish": "Светик! Куколка наша, самая скоростная, добрая и умная! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:17:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.lipovaya@aquaart.ru",
        "to": "Лидия Бронникова",
        "wish": "Ты сааааамый позитивный человек! оставайся всегда такой!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:18:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Наташа Барлеева и Саша Шацкий",
        "wish": "Наташа и Саша, спасибо за настойчивость и чёткость в реализации проекта  \"Обязательное декларирование смесителей\" "
    },
    {
        "Отметка времени": "12\/26\/2023 14:19:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Макеевой Светлане, Беляевой Надежде",
        "wish": "Наши любимые фин. контролеры! Вы лучшие!!!!!!!!!!!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:20:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Бухгалтерия КЗ",
        "wish": "Девочки Вы молодцы! Будьте всегда на позитиве!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:21:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.lebedeva@gmail.com",
        "to": "Всей бухгалтерии",
        "wish": "Спасибо за то, что делаете казалось бы невозможное возможным!!! Вы невероятно крутые!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:22:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.lebedeva@gmail.com",
        "to": "Тропиной Анне",
        "wish": "Спасибо за то, что всегда помогаешь и откликаешься"
    },
    {
        "Отметка времени": "12\/26\/2023 14:25:09",
        "Баллы": 0,
        "Ваша корпоративная почта": "egor.ksenafontov@ampm-world.com",
        "to": "Артём Мишин",
        "wish": "Спасибо за день, спасибо за ночь. С новым годом!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:25:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Плотник Николай",
        "wish": "Спасибо Николай за поддержку! С наступающим новым годом!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:26:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Тропина Анна",
        "wish": "Анечка! Ты просто наш лучик света! Спасибо огромное за твою работу! "
    },
    {
        "Отметка времени": "12\/26\/2023 14:27:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.kleybaum@aquaart.kz",
        "to": "Макеевой Светлане, Беляевой Надежде, ",
        "wish": "Выражаю искренние слова благодарности за Вашу добросовестную, отменную работу. Спасибо за Вашу целеустремлённость, за Ваши старания, за Ваше упорство, за Вашу ответственность, за Ваш потенциал и неутомимый энтузиазм. Я желаю Вам всегда добиваться своих целей, смело бороться за свой успех и никогда не бояться внезапных препятствий. Уверенности, удачи и устойчивой позиции!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:27:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "maria.kalinina@ampm-world.com",
        "to": "Мазурова Настя",
        "wish": "Настя, спасибо что ты всегда готова помочь в любом  вопросе, особенно категории wellness. Настоящий порядок в товаром учете легко помогает нам собрать новинки в быстрые сроки!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:28:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Команда продаж Маркетплейсов",
        "wish": "Хочу выразить искренние благодарность и восхищение командой продаж Маркетплейсов - вы наши путеводные звёзды в E-com пространстве, самые амбициозные и самые динамичные! И, конечно, большое спасибо Анне Петровской за  создание этой исключительной команды Ураган :)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:29:29",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.kleybaum@aquaart.kz",
        "to": "Талаевой Марине, Струк Алле, ",
        "wish": "Спасибо большое за честную и добротную работу, благодарю за Ваш энтузиазм, усердие, старание, стремление к успеху и полную самоотдачу. Будьте счастливы и успешны, пусть Вам и дальше удаётся достигать небывалых высот и радовать всех нас великолепными итогами.\n\n"
    },
    {
        "Отметка времени": "12\/26\/2023 14:30:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Саидов Дмитрий",
        "wish": "Дима, с тобой работать легко! Спасибо за приятную совместную работу!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:31:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.baycharoeva@aquaart.group",
        "to": "Евгения Пашкова",
        "wish": "За поддержку, профессионализм, деликатность и доброту"
    },
    {
        "Отметка времени": "12\/26\/2023 14:31:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Юлия Леденева",
        "wish": "Огромное спасибо Юле за чуткое отношение к бренду damixa, за неравнодушие к каждой задаче, упорядоченность и ответственность. А также за хорошее настроение, которое точно придаёт бренду новые силы."
    },
    {
        "Отметка времени": "12\/26\/2023 14:31:58",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Леконцева Иоланта",
        "wish": "Спасибо за многолетний труд и развитие продаж в ТС \"Водолей\". "
    },
    {
        "Отметка времени": "12\/26\/2023 14:32:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "evgeniya.gorpinchenko@aquaart.ru",
        "to": "Дорогим коллегам со склада",
        "wish": "Поздравляем с Наступающим Новым Годом!!! Желаю большого счастья, крепкого здоровья, любви, терпения, энергии, финансового и духовного благополучия!!!!!Вы Все молодцы!!!!!! Спасибо Вам за такой большой труд!!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:32:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "Evgeny.pokrovsky@aquaart.ru",
        "to": "Дедушке Морозу",
        "wish": "Уважаемый Дедушка Мороз, у меня сломался телефон и прохудился башмак и я хотел написать тебе письмо и попросить новые на новый год!  Но, не надо! Давай лучше подарим всем всем крепкого здоровья и светлого, мирного неба надо головой. А подарки лучше подари деткам которые так сильно в них нуждаются!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:33:09",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Махмутов Андрей",
        "wish": "Андрей, спасибо за развитие продаж на территории. За год положено хорошее начало. Уверен, все еще рекорды впереди."
    },
    {
        "Отметка времени": "12\/26\/2023 14:34:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Хрущев Никита",
        "wish": "Никита, спасибо за работу. Начало положено. Уверен, все победы еще впереди."
    },
    {
        "Отметка времени": "12\/26\/2023 14:34:30",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Фёдор Полкунов",
        "wish": "Спасибо Фёдору за наши стабильные продажи на международных рынках, за новую стратегию международных продаж, которая сработала!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:35:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Алексей Горячев",
        "wish": "Алексей!  Спасибо за наставничество и поддержку!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:36:21",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Юрий Джавадов",
        "wish": "Большая благодарность Юрию за мудрость, логику и неиссякаемый поток идей!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:37:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.baycharoeva@aquaart.group",
        "to": "Миронюк Паша",
        "wish": "Паша, спасибо за то, что сохраняешь свой профессиональный подход, не поддаешься панике и сохраняешь адекватность в условиях хаоса :-)"
    },
    {
        "Отметка времени": "12\/26\/2023 14:39:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Ахметвалеев Руслан",
        "wish": "Руслан! Спасибо за совместную работу! Спасибо за позитив! Желаю успеха, достижений в своей профессиональной сфере! С Наступающим новым годом!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:39:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Михеева Ирина",
        "wish": "Ирина, спасибо за помощь в работе и подготовке данных. Круто, что с каждым разом статистика все доступнее и информативнее."
    },
    {
        "Отметка времени": "12\/26\/2023 14:44:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Аня Панкратова",
        "wish": "Аня, спасибо за огромную проделанную работу за год! Восторгаюсь твоей выдержкой и способностью все запоминать, что, когда отгрузить, что доложить, а что убрать. Так держать!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 14:59:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "liliya.lebed@aquaart.ru",
        "to": "Елена Стешова",
        "wish": "Спасибо за вашу работу по неликвидам и ориентацию на результат!)"
    },
    {
        "Отметка времени": "12\/26\/2023 15:05:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.dmitrieva@ampm-world.com ",
        "to": "Юлия Андрулянис",
        "wish": "Спасибо, что всегда стараешься максимально быстро закрыть все заявки по отгрузкам. Более 400 машин!, отгруженных за последний год, благодаря твоей помощи и профессионализму! Желаю только хороших новостей в Новом году, ярких впечатлений и красочных событий!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:07:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "pavel.azovski@ampm-world.com",
        "to": "Спасибо Команде УТК",
        "wish": "Дорогие, спасибо за вашу энергию, мотивацию, упёртость, обстоятельность, открытость, позитив, таблички, идеи, продукты, разработки, упаковку, цены, скидки, КП и презентации, вдохновение для клиентов на существующих и новых рынках!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:16:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "lidiya.bronnikova@aquaart.group",
        "to": "Инна Колбасникова ",
        "wish": "За вдохновение и иконостильное проявление :-)"
    },
    {
        "Отметка времени": "12\/26\/2023 15:18:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "lidiya.bronnikova@aquaart.group",
        "to": "Галия Урманчиева",
        "wish": "Благодарность за трудолюбие и упорство в работе "
    },
    {
        "Отметка времени": "12\/26\/2023 15:18:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.ivanova@aquaart.ru",
        "to": "Михаил Калугин",
        "wish": "Михаил, огромное спасибо за Ваш профессионализм! Вы всегда готовы помочь! Успехов в Новом году!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:25:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.ivanova@aquaart.ru",
        "to": "Эльвира Санникова",
        "wish": "Эля, спасибо большое за твое терпение, трудолюбие и взаимопонимание! Ты светлый человечек :) Всего самого доброго в Новом году! "
    },
    {
        "Отметка времени": "12\/26\/2023 15:32:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.terleckaya@am.pm-world.com",
        "to": "Отделу логистики",
        "wish": "Дорогие друзья! Спасибо вам всем огромное за ваш такой большой и непростой труд! Срочно забрать у поставщика и оперативно доставить дефицитный товар, привезти образцы для разработок наших новинок, преодолеть любые сложности в процессе доставки и таможенного оформления, согласовать приемку товара в неприёмный день и соблюсти все интересы при доставке товаров нашим клиентам, даже в таких сложных реалиях - оказывается, это всё возможно, и это всё про вас! Счастливого вам Нового Года и успехов во всех ваших начинаниях!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:49:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "Elena Kostrikina <elena.kostrikina@aquaart.ru>",
        "to": "УП",
        "wish": "Вы самые лучшие!!! Удачи, успехов и еще больше крутых проектов!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:51:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Денис Жидовкин",
        "wish": "Известная поговорка: «Руководить — не руками водить, а пример показывать». Именно таким является Денис! Подскажет, даст совет как добиться цели\/результата и подставит плечо, если потребуется. Истинный патриот компании и фанат своего дела! Пример для многих))"
    },
    {
        "Отметка времени": "12\/26\/2023 15:56:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatyana.terleckaya@am.pm-world.com",
        "to": "Синицына Светлана",
        "wish": "Света, большое тебе спасибо за, с одной стороны, четкое, строгое и грамотное, а с другой стороны, доброе и понимающее, руководство нашим большим отделом! Лично я могу только представить, сколько сложных, но новых и интересных задач в этом году ты взяла на себя и успешно их реализовала. Иногда кажется, что ты не знаешь усталости, но все-таки хочу пожелать тебе легкого и еще более успешного Нового Года!"
    },
    {
        "Отметка времени": "12\/26\/2023 15:57:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Светлана Романенко",
        "wish": "Трудоголик без преувеличения, ВСЕГДА оперативно даст ответ на запрос, поделится информацией. Партнёры также отзываются только положительно, все рекламации отработаны чётко и без задержек. Образец \"ценного\" сотрудника (есть с кем сравнить из прошлого). Спасибо, Светлана)) Продолжай в том же духе..."
    },
    {
        "Отметка времени": "12\/26\/2023 16:05:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Пашевиной Анастасии",
        "wish": "С тобой всегда приятно общаться, ты веселый, позитивный человек! Желаю тебе в работе успехов, сил и вдохновения)) "
    },
    {
        "Отметка времени": "12\/26\/2023 16:07:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Павел Миронюк",
        "wish": "Всегда открыт к диалогу, оперативно отвечает по существу, делится имеющейся информацией, выслушивает мнение сотрудников и поддерживает их. Спасибо, Павел!"
    },
    {
        "Отметка времени": "12\/26\/2023 16:11:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Бухгалтерия",
        "wish": "Одно из моих любимых подразделений, куда всегда приятно зайти, так как всегда тебя встретят с улыбкой. Или позвонить и тебе всегда помогут решить вопрос. Я знаю, что там работают люди, которые знают свое дело) "
    },
    {
        "Отметка времени": "12\/26\/2023 16:16:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Светлана Горшкова",
        "wish": "Крайне ответственна, не откладывает дела в \"долгий ящик\", всё чётко и точно - это про Светлану. Настоящий профессионал своего дела! Благодарю за совместную работу, помощь и содействие в решении вопросов, и просто за человеческое отношение!"
    },
    {
        "Отметка времени": "12\/26\/2023 16:32:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Сергей Шунков",
        "wish": "Харизма, подача обучающего материала, профессионализм, а в целом - Гуру в мире Сантехники! Крутой тренер и отличный коллега! Неоднократно проводил онлайн-обучения для сотрудников Юга Леруа Мерлен, выполнение и перевыполнение плана - часть заслуги Сергея. Благодарю за отношение и подход к работе! "
    },
    {
        "Отметка времени": "12\/26\/2023 16:36:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "Oleg.Shumko@aquaart.ru",
        "to": "Ирина Ледянкина",
        "wish": "Огромная благодарность за внедрение ЭДО!!! Забот стало меньше у многих коллег. Приятно работать и взаимодействовать по обоюдным задачам)) Умница и Красавица!!!"
    },
    {
        "Отметка времени": "12\/26\/2023 16:47:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.ledyankina@aquaart.ru",
        "to": "Емельянова Наталья",
        "wish": "Наташа, спасибо за качественную работу.Так держать!"
    },
    {
        "Отметка времени": "12\/26\/2023 16:55:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.ledyankina@aquaart.ru",
        "to": "Войницкая Виктория",
        "wish": "Виктория, спасибо тебе! Ты очень душевный человек, ответственный работник, всегда придешь на помощь и поддержишь. "
    },
    {
        "Отметка времени": "12\/26\/2023 16:59:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Татьяна Истомина",
        "wish": "Таня, спасибо за твою лучезарность и всегда прекрасное настроение. С тобой очень приятно работать по всем вопросам :) Успехов и новых высот в наступающем году!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:01:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru",
        "to": "Владислав Ковнацкий",
        "wish": "Влад, спасибо за супер вовлеченность, самостоятельность и быстрое решение вопросов"
    },
    {
        "Отметка времени": "12\/26\/2023 17:03:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Татьяна Климкина",
        "wish": "Танечка, спасибо, что ты есть, за твою харизму, юмор, блистательную улыбку и профессионализм !)"
    },
    {
        "Отметка времени": "12\/26\/2023 17:06:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Ирина Сабо",
        "wish": "Ира, спасибо, что ты как палочка выручалочка помогаешь международному офису продвигаться в новой стране"
    },
    {
        "Отметка времени": "12\/26\/2023 17:09:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "svetlana.sinicina@aquaart.ru   ",
        "to": "Леонид Матвеевич Хазанов",
        "wish": "Спасибо Вам за возможности, которые дает компания и за опыт, которым Вы делитесь. И конечно, за тот драйв, который не дает остановиться!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:18:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.ledyankina@aquaart.ru",
        "to": "ИТ",
        "wish": "Спасибо за помощь и поддержку при внедрении КЭДО."
    },
    {
        "Отметка времени": "12\/26\/2023 17:27:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.mikhailova@aquaart.ru",
        "to": "Виктория Демидова",
        "wish": "Спасибо за приятную и конструктивную коммуникацию!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:28:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.mikhailova@aquaart.ru",
        "to": "Петрова Эльвира",
        "wish": "Спасибо за ответы на все вопросы, ты супер-мозг)"
    },
    {
        "Отметка времени": "12\/26\/2023 17:28:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.mikhailova@aquaart.ru",
        "to": "Светлана Синицына",
        "wish": "Спасибо за супер способность решить любую задачу!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:38:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "Daria.Klimova@aquaart.ru",
        "to": "Бородин Александр",
        "wish": "Спасибо большое за все :)"
    },
    {
        "Отметка времени": "12\/26\/2023 17:44:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "nikolay.plotnik@ampm-world.com",
        "to": "ФЭУ",
        "wish": "Огромное спасибо всему дружному коллективу ФЭУ за самоотверженную работу!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:45:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "nadezhda.smirnova@aquaart.ru",
        "to": "Надежде Суриковой",
        "wish": "Спасибо за постоянную поддержку , хорошее настроение и поддержание духа в команде!)"
    },
    {
        "Отметка времени": "12\/26\/2023 17:51:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "maria.kalinina@ampm-world.com",
        "to": "Синицына Светлана",
        "wish": "Света, спасибо за твою безудержную энергию и поддержку во всех начинаниях. Еще больше удачи, фантастических проектов и счастья в новом году!"
    },
    {
        "Отметка времени": "12\/26\/2023 17:58:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "andrey.taskaev@ampm-world.com",
        "to": "Управление Логистики",
        "wish": "Спасибо за быструю доставку! \nКратный рост в отгрузках!\nВключённость и точность в работе!"
    },
    {
        "Отметка времени": "12\/26\/2023 18:00:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "andrey.taskaev@ampm-world.com",
        "to": "Служба Сервиса",
        "wish": "Самые терпеливые операторы и лучший постгарантийный сервис! "
    },
    {
        "Отметка времени": "12\/26\/2023 18:01:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "andrey.taskaev@ampm-world.com",
        "to": "СКК",
        "wish": "Ребята, спасибо за вашу внимательность! "
    },
    {
        "Отметка времени": "12\/26\/2023 18:03:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Марина Бугорская",
        "wish": "Спасибо за идеи классных фотосессий, наши соц.сети заиграли новыми красками! А ещё - за умение включаться в любой процесс, подхватывать и быть всегда доброжелательной и отзывчивой."
    },
    {
        "Отметка времени": "12\/26\/2023 18:03:30",
        "Баллы": 0,
        "Ваша корпоративная почта": "andrey.taskaev@ampm-world.com",
        "to": "Управление Маркетинга",
        "wish": "Самые креативный маркетинг в отрасли! У вас всё по-новому!"
    },
    {
        "Отметка времени": "12\/26\/2023 18:10:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Екатерина Пименова",
        "wish": "Огромное спасибо за бешеную работоспособность, ответственность, яркую эмоциональность, которая отражается во всём - и в первую очередь, в самом ярком и  эмоциональном контенте :)"
    },
    {
        "Отметка времени": "12\/26\/2023 18:13:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Карина Пачина",
        "wish": "Спасибо за насмотренность, желание привнести вкус и красоту во всё, что мы делаем, за умение близко коммуницировать с самыми далёкими регионами."
    },
    {
        "Отметка времени": "12\/26\/2023 18:16:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Влад Федюнцов",
        "wish": "Спасибо Владу за профессионализм и умение развиваться в самых разных областях, за стремление к росту на пользу и во благо компании."
    },
    {
        "Отметка времени": "12\/26\/2023 18:16:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Ермакова Екатерина",
        "wish": "Екатерина, я искренне благодарен за то, что в 2015 году Вы поверили в меня!\nМоё развитие в компании, как тренинг менеджера стало возможным благодаря Вам! \nВнимание, терпение, умелое руководство и мотивация, а так же личное Ваше участие -   вот волшебный рецепт моего успеха! \nБлагодарю Вас! Вы лучший руководитель! И очень хороший человек!"
    },
    {
        "Отметка времени": "12\/26\/2023 18:17:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Шилову Евгению",
        "wish": "Евгений, хочу сказать Вам спасибо за то, что Вы всегда оперативно подписываете документы. За Вашу мега-организацию сотрудников, за сопровождение при подписании документов - спасибо! "
    },
    {
        "Отметка времени": "12\/26\/2023 18:17:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "maria.kalinina@ampm-world.com",
        "to": "Склад и производство (Служба операционной логистики)",
        "wish": "Евгений Шилов, Артур Островский, Павел Иванов, Дарья Десятник, Анастасия Мазурова, Саша Васильев, Роман Горпиченко, Eвгений Шматов, Дима Дамиров и много много еще можно вас называть, спасибо за ваше бесконечное чувство юмора, за быструю и качественную сборку товаров на производстве, готовность принять и отгрузить товар в любой день недели, в любое время суток! "
    },
    {
        "Отметка времени": "12\/26\/2023 18:20:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Леонид Матвеевич ",
        "wish": "Начиная с 2008 года, именно тогда я стал частью команды Aquaart. Я наблюдаю, как Вы направляете компанию к успеху. Это поразительно, год за годом, весь мир переживает кризисы, тогда как компания находит в этом только возможности. Работая в Aquaart, я понимаю - что тружусь плечом к плечу с теми, кто любит вызовы, теми, кто обожает ставить рекордны и пример мы берём с Вас! \nСпасибо Вам Леонид Матвеевич за Aquaart"
    },
    {
        "Отметка времени": "12\/26\/2023 18:21:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "yana.loshkareva@aquaart.ru",
        "to": "Александр Артюшин",
        "wish": "Большая благодарность Александру за умение лидировать в самых разных проектах, работать нонстоп в режиме многозадачности, оказывать поддержку разным управлениям, оставаясь всегда эстетом и гедонистом :)"
    },
    {
        "Отметка времени": "12\/26\/2023 18:36:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "Ekaterina.Yandolina@aquaart.ru",
        "to": "Ермаковой Екатерине ",
        "wish": "Екатерина, спасибо Вам за уважение к каждому сотруднику, за Ваш профессионализм, за Ваш энтузиазм браться за новые и новые проекты в компании! Вы руководитель, который умеет вдохновлять и восхищать. Желаю Вам здоровья и отличного настроения! "
    },
    {
        "Отметка времени": "12\/26\/2023 19:04:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Юрий Быковский",
        "wish": "Спасибо большое за помощи и поддержку в работе, за советы, которые мне очень помогли. Как бы сильны мы не были, поддержка увеличивает наши силы! Она, как глоток свежего воздуха, когда наваливаются трудности и не дают дышать! Спасибо за поддержку! Искренне, от всего сердца, благодарю за помощь, своевременную и такую необходимую. Пусть вернётся вам добро здоровьем, благополучием, щедрыми помогающими руками в нужный час. Спасибо за содействие!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:07:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Талаева Марина",
        "wish": "Человек нуждается в помощи намного чаще, чем кричит о ней. Но случается, что тебе помогают именно в тот момент, когда необходимо. В таком случае благодарность не знает границ. Спасибо за помощь и поддержку от всего сердца!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:12:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Михаил Калугин",
        "wish": "Спасибо за помощь!!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:32:46",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Радмиле Покраяц",
        "wish": "Спасибо за юридическую поддержку в реализации проекта Европейский офис! Вы настоящий профессионал, на которого всегда можно положиться и который поможет решить любой. даже самый сложный вопрос!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:35:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Черкасову Андрею",
        "wish": "Спасибо за новые уютные офисы для ФЭУ и Проекты, за великолепную кофе-зону в офисе СПб. "
    },
    {
        "Отметка времени": "12\/26\/2023 19:37:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Альбина Замиловой",
        "wish": "Альбина, спасибо за профессионализм, за четкое и приятное взаимодействие с командой УП, за адаптацию Анастасии. Вы человек, с которого хочется брать пример!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:41:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Бородину Александру",
        "wish": "Спасибо за умение находить новые подходы в аналитике, за умение быстро выдавать результат, спокойно, четко, без эмоций! За позитивный настрой и веру в успех компании и команды!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:45:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Александру Артюшину",
        "wish": "Спасибо за классный дизайн кофе-зоны в офисе УК, за креативные идеи, за инновационные подходы во всем, за четкость во взаимодействии, умение поддержать и вдохновлять команду в сложных ситуациях! "
    },
    {
        "Отметка времени": "12\/26\/2023 19:49:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "УМ",
        "wish": "За классные идеи и реализованные проекты! Наш маркетинг самый лучший!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:49:58",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.orlov@aquaart.ru",
        "to": "Покровский Евгений",
        "wish": "Лучший руководитель, всегда направит, подскажет, поможет, выслушает о наболевшем и решит все вопросы в кратчайшие сроки. Моё Уважение и Восхищение)))"
    },
    {
        "Отметка времени": "12\/26\/2023 19:50:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "ФЭУ",
        "wish": "Спасибо за понимание и помощь в сложных ситуациях, требующих быстрых решений и оперативных действий."
    },
    {
        "Отметка времени": "12\/26\/2023 19:53:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "УТК",
        "wish": "Спасибо за классные продукты и коллекции! Понимаю сколько труда и души вы вкладываете в разработку! Горжусь вами и нашими продуктами!"
    },
    {
        "Отметка времени": "12\/26\/2023 19:55:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "DO",
        "wish": "Спасибо за крутую Digital Елку! \n"
    },
    {
        "Отметка времени": "12\/26\/2023 19:59:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Наталье Емельяновой",
        "wish": "Спасибо за Ваш вклад в развитие производства - за классную команду ЭПК, за Ваш профессионализм и высокую эффективность! "
    },
    {
        "Отметка времени": "12\/26\/2023 20:03:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Алексею Горячеву",
        "wish": "Спасибо за классный результат, за крутую команду, за позитив, энергию и высокую вовлеченность! "
    },
    {
        "Отметка времени": "12\/26\/2023 20:03:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "alena.shmatokhina@ampm-world.com",
        "to": "Татьяна Климкина",
        "wish": "Таня, хочу выразить тебе благодарность за то, что ты такой поистине профессиональный руководитель, который всегда поможет с решением любого вопроса! Желаю в следующем году меньше стресса, много денег и больше радовать всех своей улыбкой!"
    },
    {
        "Отметка времени": "12\/26\/2023 20:05:54",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ermakova@aquaart.ru",
        "to": "Дмитрию Саидову",
        "wish": "Спасибо за готовность и желание обучать и  развивать команду, за активное участие в разработке Системы развития Талантов!"
    },
    {
        "Отметка времени": "12\/26\/2023 20:09:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "alena.shmatokhina@ampm-world.com",
        "to": "Андрей Дергунов",
        "wish": "Андрей, хочу выразить тебе благодарность за твою отзывчивость, смешные шутки, яркие идеи. Желаю, чтобы в новом году было много счастья, меньше стресса и борщ не только по средам!"
    },
    {
        "Отметка времени": "12\/26\/2023 20:12:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "alena.shmatokhina@ampm-world.com",
        "to": "Андрей Величко",
        "wish": "Андрей, хочу выразить тебе благодарность за твою отзывчивость, смешные шутки и твои оригинальные идеи!  Желаю, чтобы в новом году было много счастья, меньше стресса и чаще улыбаться!"
    },
    {
        "Отметка времени": "12\/26\/2023 20:41:09",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Алексей Горячев",
        "wish": "Хочу сказать ОГРОМНОЕ спасибо Алексей, за возможность работать с Вами, под Вашим мудрым и чутким руководством, за возможность заниматься любимым делом. Хочу выразить  искреннюю, глубокую благодарность за оказанную поддержку и помощь, за неоценимое внимание и человеческое тепло! Мы будем стараться и в знак благодарности, делать дело добросовестно, с полной отдачей и ответственностью! Желаю еще больше побед в новом 2024 году!! "
    },
    {
        "Отметка времени": "12\/26\/2023 20:47:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Денис Перминов",
        "wish": "Денис, пусть успех, признание и удача сопровождают каждое Ваше начинание. Желаем Вам интересных плодотворных идей, успешной их реализации, далеко идущих планов и стабильного финансового положения! Будьте здоровы и счастливы! С Наступающим новым 2024 годом! \n"
    },
    {
        "Отметка времени": "12\/26\/2023 20:52:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Анна Панкратова ",
        "wish": "Анюта, пусть Новый 2024 год принесет тебе много счастья, гони прочь серые мысли, проблемы. Важно не сдаваться и притягивать к себе позитивных людей. Пусть в семье царит покой, в душе мир, в кошельке приумножается капитал. Больше тебе позитивных эмоций в наступающем году, здоровья только крепкого важно, чтобы каждое желание непременно сбылось. Ты большая умничка, желаю успехов в новой должности! Знай, я буду скучать.. Ты мой лучезарный человек. "
    },
    {
        "Отметка времени": "12\/26\/2023 20:55:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Никита Хрущев ",
        "wish": "Никита,  поздравляю с волшебным Новым годом! Пусть настроение будет праздничным, желание радоваться жизни — постоянным. Пусть всё складывается как положено, мечтания исполняются, цели достигаются, счёт пополняется, новые связи появляются. Никогда не унывай: всё у тебя получится, друзья помогут, родные и близкие поддержат. Смотри вперёд с оптимизмом, и пусть в жизни будет только счастье! "
    },
    {
        "Отметка времени": "12\/26\/2023 21:43:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "Roman.Gubich@aquaart.ru",
        "to": "Денис Жидовкин",
        "wish": "За Победу в Леруа Мерлен"
    },
    {
        "Отметка времени": "12\/27\/2023 4:43:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "АННА ТРОПИНА",
        "wish": "Анечка,благодарим за профессиональную помощь,добра,мира,здоровья в наступающем году!"
    },
    {
        "Отметка времени": "12\/27\/2023 4:45:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Марина Талаева",
        "wish": "Марина Александровна,хочу выразить Вам благодарность за поддержку и за Ваш профессионализм!Спасибо Вам большое!\n"
    },
    {
        "Отметка времени": "12\/27\/2023 4:46:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Михайличенко Анастасия",
        "wish": "Настя,пусть все твои желания сбудутся,счастья в новом году!\n"
    },
    {
        "Отметка времени": "12\/27\/2023 4:48:05",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Кенжегалиева Айнура",
        "wish": "Айнурочка,спасибо за поддержку и за твоё увлечение картами ТАРО)))Всех благ в наступающем новом году!\n"
    },
    {
        "Отметка времени": "12\/27\/2023 4:51:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Надежда Беляева",
        "wish": "Надюша,от всего нашего немногочисленного отдела бухгалтерии КЗ хотим пожелать Вам всего самого наилучшего и сказать Вам большое спасибо за Ваше умение и спокойствие в любой ситуации! За Вашу доброжелательность и отзывчивость!"
    },
    {
        "Отметка времени": "12\/27\/2023 4:51:56",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Светлана Клейбаум",
        "wish": "Спасибо,что ты есть!"
    },
    {
        "Отметка времени": "12\/27\/2023 4:52:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Марина Талаева",
        "wish": "Спасибо,что ты есть!\n"
    },
    {
        "Отметка времени": "12\/27\/2023 6:52:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "alla.struk@aquaart.kz",
        "to": "Марина Талаева",
        "wish": "СПАСИБО лучшему наставнику и помощнице,готовой подставить своё плечо в любой момент и просто самому доброму и чудесному человеку!"
    },
    {
        "Отметка времени": "12\/27\/2023 6:59:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Вероника Синеякова ",
        "wish": "Дорогая Вероника! От всей души поздравляю вас с Новым 2024 годом! Искренне желаю вам вовремя сданных отчетов, веселых корпоративов и безусловно осуществления задуманного! Пусть друзья, коллеги и близкие радуют своей поддержкой и понимаем! Спасибо вам огромное за постоянную помощь, за отзывчивость и доброту! "
    },
    {
        "Отметка времени": "12\/27\/2023 7:05:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "iolanta.lekontseva@aquaart.ru",
        "to": "Анна Хазанова",
        "wish": "Анна, спасибо Вам за вашу доброту, за нежность и искренность! Вы самый лучезарный и светлый человек! Желаю Вам в Новом 2024 году, что бы в Ваши двери постучалась радость и добро. Желаю отличных подарков от Деда Мороза. Желаю здоровья, достатка и мира. И пусть этот год будет невероятно успешным."
    },
    {
        "Отметка времени": "12\/27\/2023 7:49:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "Nikita.khruschev@aquaart.ru",
        "to": "Иоланта Леконцева",
        "wish": "Лана, спасибо за непрерывную поддержку, чуткость и преданность своей работе <3"
    },
    {
        "Отметка времени": "12\/27\/2023 7:50:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "Andrey.Makhmutov@aquaart.ru",
        "to": "Дарина",
        "wish": "Спасибо за оперативное, четкое решение наших текущих вопросов"
    },
    {
        "Отметка времени": "12\/27\/2023 7:50:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "Nikita.khruschev@aquaart.ru",
        "to": "Анна Панкратова",
        "wish": "Аня - замечательный человек, который придёт на помощь в сложной ситуации. Спасибо тебе за терпение и профессионализм! "
    },
    {
        "Отметка времени": "12\/27\/2023 7:50:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "Nikita.khruschev@aquaart.ru",
        "to": "Денис Перминов",
        "wish": "Денис, спасибо за профессионализм и богатый опыт, который помогает принимать решения, приносящие крутые результаты! "
    },
    {
        "Отметка времени": "12\/27\/2023 7:51:35",
        "Баллы": 0,
        "Ваша корпоративная почта": "Nikita.khruschev@aquaart.ru",
        "to": "Алексей Горячев",
        "wish": "Алексей - крутой пример целеустремлённости и находчивости, который заряжает на достижение новых вершин. Спасибо Вам за это! "
    },
    {
        "Отметка времени": "12\/27\/2023 7:53:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "Andrey.Makhmutov@aquaart.ru",
        "to": "Бизнес- администраторы",
        "wish": "Удачи, здоровья, терпения в 2024 году, спасибо вам за вашу помощь в совместной работе"
    },
    {
        "Отметка времени": "12\/27\/2023 8:38:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "elena.mikheeva@aquaart.ru",
        "to": "Елена Перышкина (финансовый отдел Москвы)",
        "wish": "Спасибо за взаимовыручку, за поддержку, за отзывчивость, за нужные решения! Елена всегда \"держит руку на пульсе\"! Желаю ей благополучия и процветания!"
    },
    {
        "Отметка времени": "12\/27\/2023 9:48:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Управлению ИТ ",
        "wish": "Спасибо за крутой проект ERP и за то, что двигаете Акваарт вперед к еще большей инновационности и автоматизации! "
    },
    {
        "Отметка времени": "12\/27\/2023 9:48:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Ирине Латфуллиной",
        "wish": "Без тебя, не было бы таких результатов! Ставим отличнице 5! ;-)"
    },
    {
        "Отметка времени": "12\/27\/2023 9:49:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Елене Стешовой",
        "wish": "Лена, ты мечта любого руководителя, поэтому за тебя такая борьба! ;-)"
    },
    {
        "Отметка времени": "12\/27\/2023 9:49:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Дмитрий Саидов",
        "wish": "Спасибо за крутые рекорды и позитивный настрой в развитии Легких Рынков! И, конечно, спасибо за инициативу и участие во многих проектах компании! "
    },
    {
        "Отметка времени": "12\/27\/2023 9:50:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Денису Иванову",
        "wish": "Ты - универсальный солдат. И нет сомнения, что если что-то тебя попросить, это будет сделано на высшем уровне! Спасибо за годы работы!"
    },
    {
        "Отметка времени": "12\/27\/2023 9:50:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Алексей Горячев и команда СРП ",
        "wish": "Спасибо за крутое развитие СРП и классные результаты продаж в 2023 году! Вы лучшие!"
    },
    {
        "Отметка времени": "12\/27\/2023 9:51:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Вадиму Истратию",
        "wish": "Твой вклад сложно переоценить! Без тебя, таких результатов было бы не достигнуть. Сама судьба подарила тебя нашей компании! )"
    },
    {
        "Отметка времени": "12\/27\/2023 9:51:35",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Сергей Сабуров ",
        "wish": "Спасибо за крутые предложения в Банк Идей и за то, что реализуешь их уже сейчас! "
    },
    {
        "Отметка времени": "12\/27\/2023 9:52:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru ",
        "to": "Радмила Покраяц ",
        "wish": "Радмила, спасибо тебе за твой профессиональный подход, за исключительную внимательность в самых тонких и сложных вопросах! Ты настоящий профессионал своего дела и с тобой наша команда всегда под надежной юридической защитой! :) "
    },
    {
        "Отметка времени": "12\/27\/2023 9:52:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Свете Залесской",
        "wish": "Светик - ты сотрудник, о котором мечтают. Уверен, другие отделы даже завидуют ;-)\nСпасибо тебе за все!"
    },
    {
        "Отметка времени": "12\/27\/2023 9:53:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.khazanova@aquaart.ru",
        "to": "Елена Стешова",
        "wish": "Лена, спасибо большое за крутые результаты на маркетплейсах! Очень радостно видеть твой рост и развитие! "
    },
    {
        "Отметка времени": "12\/27\/2023 9:53:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Андрею Таскаеву",
        "wish": "Чтобы там ни было и как бы сложно не приходилось. Ты один из самых ответственных сотрудников, с которыми доводилось работать. Спасибо!"
    },
    {
        "Отметка времени": "12\/27\/2023 9:55:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "fedor.polkunov@aquaart.ru",
        "to": "Яне Лошкаревой",
        "wish": "Ты пример руководителя, к которому мы должны стремиться, а ответственность, четкость и мудрость завораживает. Спасибо тебе!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:06:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "inna.nikitina@aquaart.group",
        "to": "Васильев Михаил",
        "wish": "Спасибо тебе за умение поддержать в самые сложные рабочие моменты! Ты супер! Самый организованный и ответственный. "
    },
    {
        "Отметка времени": "12\/27\/2023 10:35:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "ashatsky@aquaart.ru",
        "to": "Екатерина Черепанова",
        "wish": "Катя, спасибо за креативность, внимательность и стремление к совершенству в каждой детали. Без тебя никуда. С Новым Годом!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:49:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "DO",
        "wish": "Ребята, спасибо вам за великолепное сотрудничество, всегда позитивный настрой и радость! И за эту красивую Digital елку, которая приносит такие классные эмоции!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:50:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.lebed@aquaart.ru",
        "to": "Виталий Курган",
        "wish": "Спасибо за поддержку инициатив и предоставление инструментов для развития продаж"
    },
    {
        "Отметка времени": "12\/27\/2023 10:51:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Арина Вычигина",
        "wish": "Ариша, спасибо за твой позитив и прекрасную работу! Желаю и дальше отличных результатов и баланса во всех сферах жизни!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:52:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Марина Истратий",
        "wish": "Мариша, спасибо тебе за работу и нереальный прорыв в международном подборе в первые же месяцы работы! Ты прекрасный профессионал и отличный командный игрок! Благодарю за поддержку!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:53:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Антон Биткин",
        "wish": "Антон, поздравляю с быстрой адаптацией в команду, пусть в новом году будет много свершений и открытий!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:53:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Василий Швецов",
        "wish": "Вася, спасибо за поддержу! Желаю новых высот в новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:54:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.ledeneva@damixa.ru ",
        "to": "УТК",
        "wish": "Ребята, спасибо за поддержку, за то, что болеете душой за каждый продукт. Вы очень много делаете для развития категорий. Так держать! И сил вам!)"
    },
    {
        "Отметка времени": "12\/27\/2023 10:57:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Инночка Никитина",
        "wish": "Дорогая, поздравляю тебя с Наступающим! Пусть в Новом году будет много счастья и путешествий! Ждем в гости!"
    },
    {
        "Отметка времени": "12\/27\/2023 10:58:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.ledeneva@damixa.ru ",
        "to": "Маркетинг",
        "wish": "Самые креативные, отзывчивые и душевные ребята! Спасибо вам за классный контент, идеи и хорошее настроение! И за соль))"
    },
    {
        "Отметка времени": "12\/27\/2023 10:59:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Анна Миронова",
        "wish": "Аня, спасибо за твою работу и прекрасные результаты! Ты крутая! Пусть в новом году будет еще больше прорывных достижений и успехов! Любви и счастья"
    },
    {
        "Отметка времени": "12\/27\/2023 10:59:33",
        "Баллы": 0,
        "Ваша корпоративная почта": "Yuliya.Voropaeva@aquaart.ru",
        "to": "Маркетплейсы СПб",
        "wish": "Благодарю Руководителя и Коллег за поддержку и помощь! Вы замечательные и с классным чувством юмора) Рада работать с Вами) "
    },
    {
        "Отметка времени": "12\/27\/2023 10:59:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ionova@aquaart.ru",
        "to": "ФЭУ МОСКВА",
        "wish": "Коллеги, огромное вам спасибо за еще один плодотворный год вместе! Работать в такой КОМАНДЕ - одно удовольствие! Вы-настоящие профессионалы и просто хорошие люди! Желаю такого же энтузиазма и упорства в работе на будущий год! Всех с Наступающим!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:00:09",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "КДП",
        "wish": "Девочки, спасибо за ваш труд и сотрудничество! Успехов в новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:02:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.konovalova@aquaart.ru",
        "to": "Алексею Смирнову и Алексею Перцеву",
        "wish": "Спасибо большое за помощь и оперативное решение вопросов! Вы лучшие!!!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:02:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Серёжа Шунков",
        "wish": "Серёжа, спасибо за крутой настрой! Ты лучший тренер и прекрасный коллега! Пусть в Новом году у тебя всегда будет такое же крутое настроение и больше поводов для радости!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:04:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.ledeneva@damixa.ru ",
        "to": "УД",
        "wish": "Спасибо всем-всем-всем)) За отличную выставку 1-ой волны damixa. Без вас бы ничего не получилось! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:04:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Радмила",
        "wish": "Радмила, спасибо за твой бесценный труд и профессиональную помощь, супер поддержку и дружбу! Пусть Новый год будет наполнен новыми свершениями и положительными впечатлениями!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:05:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "olga.konovalova@aquaart.ru",
        "to": "СКС МСК ",
        "wish": "Спасибо за прекрасную Команду, взаимовыручку и дружный коллектив!!! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:06:03",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Леонид Матвеевич",
        "wish": "Леонид Матвеевич, спасибо за Ваше прекрасное руководство, а самое главное вдохновение на работу и новые открытия! Работая здесь и правда начинаешь мечтать о Большем и получать удовольствие от работы. Спасибо за доверие!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:06:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "Mikhail.Vasiliev@aquaart.ru",
        "to": "Лысенко Алексей",
        "wish": "Благодарность за профессионализм и умение решить любую задачу! :)"
    },
    {
        "Отметка времени": "12\/27\/2023 11:06:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.ledeneva@damixa.ru ",
        "to": "Мария Куликова",
        "wish": "Маша, спасибо за то, что ты появилась в команде УТК! С тобой стало намного быстрее и проще делать крутые работы!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:07:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "ИТ",
        "wish": "Коллеги, спасибо за вашу помощь в работе и быстрое реагирование на вопросы! Успехов в новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:07:34",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.ledeneva@damixa.ru ",
        "to": "Ксения Шувагина",
        "wish": "Спасибо за то, что ты делаешь для бренда damixa. За поддержку, мотивацию и хорошее настроение!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:08:11",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.Pankratova@aquaart.ru",
        "to": "Светлана Борисова",
        "wish": "Света, спасибо за отличную работу! Ты всегда проявляешь ответственность, оперативность при выполнении любой задачи! Лучший РМ! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:09:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Арина и Саша",
        "wish": "Арина и Саша, спасибо за вашу помощь по всем офисным вопросам! Пусть будет много радости, подарков, счастья и любви в новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:11:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Юрий Джавадов",
        "wish": "Юра, спасибо за отличную работу и классное взаимодействие! И, конечно, за всегда хорошее настроение! Пусть в новом году E-com достигнет еще больших высот! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:12:06",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "ФЭУ",
        "wish": "Коллеги, спасибо за вашу работу! Вы лучшие! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:14:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Артем Мишин",
        "wish": "Артем, спасибо за быстрое реагирование и взаимодействие по работе по любым вопросам! Пусть в следующем году будет еще больше открытий, радостей и достижений!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:15:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "diana.ivanova@aquaart.ru",
        "to": "Францужан Анастасия",
        "wish": "Спасибо тебе за то, что каждый день даришь нам улыбки и поднимаешь настроение! Удачного прохождения практики в нашей компании, отличной защиты диплома и много положительных эмоций в новом году:) Ты супер!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:16:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Андрей Таскаев",
        "wish": "Андрей, спасибо за плодотворное сотрудничество и отличное настроение! Пусть в Новом году все мечты воплощаются в жизнь!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:18:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.frantsuzhan@aquaart.group",
        "to": "Иванова Диана",
        "wish": "Благодарю от всего сердца Дианочку за оперативную работу, приятное общение и профессионализм! Ты заряжаешь коллег позитивом и приносишь счастье! Пусть сбудутся все желания, а коллектив этому поспособствует!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:18:40",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Наталья Барлеева",
        "wish": "Наталья, спасибо за совместную работу! Пусть в Новом году сбываются Ваши мечты и цели!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:23:33",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Света Залесская",
        "wish": "Света, спасибо тебе за нереальную организацию Созвездия 2023! Это было потрясающе! За такой чудесный офис для коллег в Европе! И в целом за поддержку и позитив! Обнимаю и желаю всего самого лучшего и теплого)"
    },
    {
        "Отметка времени": "12\/27\/2023 11:26:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Леонид Матвеевич",
        "wish": "Большое спасибо, что поверили в меня и взяли на работу! Очень приятно работать в компании, где так заботятся о своих сотрудниках, где все стараются ради общего дела, где производятся высококлассная и очень нужная продукция! Желаю Вам и нашей компании процветания и благополучия в Новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:26:58",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Дима Саидов",
        "wish": "Дима, поздравляю за крутой прорыв в этом году! Желаю, чтобы ЛР развивались еще круче под твоим руководством! С Наступающим!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:27:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Николай Плотник",
        "wish": "Спасибо за терпение, понимание и поддержку! Буду стараться поменьше болеть в Новом году! А вам желаю крепкого здоровья и успехов во всех делах! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:28:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Кристина Коньшакова",
        "wish": "Кристина, спасибо тебе за помощь в этом году! Пусть в новом году будет очень много радостей!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:28:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Анна Минаева",
        "wish": "Спасибо, Анечка, за твою целеустремленность, помощь и всегда позитивный настрой! Ты классная!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:29:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Яна Небывалова",
        "wish": "Благодарю за готовность помочь всегда и быстро, за чувство юмора и неординарность! Удачи и исполнения желаний в Новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:31:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Наталья Яковенко",
        "wish": "Как же классно, что мы работаем вместе и стремимся сделать работу компании лучше! А ты - очень позитивный и ответственный человек! Удачи, здоровья и положительных эмоций в Новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:32:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Ира Сабо",
        "wish": "Спасибо за помощь в решении всех вопросов! Здоровья и благополучия в Новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:34:35",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.martynova@ampm-world.com",
        "to": "Федор Канашин",
        "wish": "Спасибо за оперативность, за неравнодушие, за позитив и готовность решать любые сложные задачи! Только всего самого светлого, развития бизнеса и новых достижений в Новом году! а еще, чтобы в ПСКБ нам открыли счет без всяких проволочек!:)"
    },
    {
        "Отметка времени": "12\/27\/2023 11:41:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalia.magomedaminova@aquaart.ru",
        "to": "Павел Иванов и Юрий Быковский",
        "wish": "Хотим выразить искреннюю благодарность за непрерывную поддержку и  высокий профессионализм. Большое спасибо за ваш труд, ценные советы и вдохновляющий пример в достижении поставленных целей. С Наступающим вас Новым Годом! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:43:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalya.ivanova@aquaart.ru",
        "to": "Ренат Гатауллин",
        "wish": "Ренат, спасибо за упорство, стойкость и трудоспособность! Мне с тобой повезло. Пусть все жизненные невзгоды останутся в уходящем году. Пусть в Новом году сбудется все, что задумано!!!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:43:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "irina.revenko@aquaart.ru",
        "to": "Михеева Ирина",
        "wish": "Хочу поблагодарить Ирину за отзывчивость, готовность обучать и помогать, она профессионал, который легко делиться своими знаниями и умениями. Рада, что в коллективе у меня есть такой близкий по духу человек!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:43:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "АА ЦА",
        "wish": "Коллеги! Мы, профессиональная команда! Спасибо Вам за активную работу! За душевную обстановку! Желаю Всем карьерного взрыва! Пусть все мечты сбудутся! Ваша Бухгалтерия.."
    },
    {
        "Отметка времени": "12\/27\/2023 11:44:38",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Алла Струк",
        "wish": "Алла! Терпение тебе!  Ты умница! "
    },
    {
        "Отметка времени": "12\/27\/2023 11:46:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Михайличенко Анастасия",
        "wish": "Анастасия! С наступающим новым годом! Дерзай и все будет хорошо!"
    },
    {
        "Отметка времени": "12\/27\/2023 11:47:29",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Надежда Беляева",
        "wish": "Надежда, спасибо Вам! Работа с Вами просто счастье! "
    },
    {
        "Отметка времени": "12\/27\/2023 12:05:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.petrovskaya@aquaart.ru",
        "to": "Команда Маркетплейсы РФ",
        "wish": "Вы - Dream Team любого руководителя! Каждому из Вас желаю развития, самореализации, хладнокровия в любой ситуации , ну и, конечно же, чтобы в Новом году сбылась ваша заветная мечта. Ну и денег всем желаю побольше)))) ;-) "
    },
    {
        "Отметка времени": "12\/27\/2023 12:10:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.talaeva@aquaart.kz",
        "to": "Леонид Матвеевич",
        "wish": "Спасибо Вам, за то что мы есть! Спасибо за наши возможности! Процветания нашей компании!!!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:14:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "valeria.kolesnichenko@aquaart.group",
        "to": "Гилев Виталий,Новоятлов Михаил и Вардугин Дмитрий",
        "wish": "Спасибо за Вашу поддержку, готовность помочь с любыми вопросами и четкой реализацией автоматизации нашей любимой ERP!С вами работать одно удовольствие!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:14:28",
        "Баллы": 0,
        "Ваша корпоративная почта": "Svetlana.Neskoromnaya@aquaart.ru",
        "to": "Руководителю СКС Москвы Михальчук Татьяне и всем сотрудникам",
        "wish": "С Новым Годом самые лучшие, добрые, прекрасные, чудесные коллеги!!!!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:16:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "valeria.kolesnichenko@aquaart.group",
        "to": "Лебедь Лилия",
        "wish": "Спасибо, что ты всегда ищешь плюсы в любых изменениях и остаешься позитивной!Заряжая людей вокруг своим прекрасным настроением и любовью к миру!)"
    },
    {
        "Отметка времени": "12\/27\/2023 12:20:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "maxim.demin@aquaart.ru",
        "to": "АКВААРТ",
        "wish": "Спасибо за экстраординарные подходы к деятельности, выпускаемые продукты, заряженную команду! Все это дает возможность видеть мир через характерную призму, она впечатляет."
    },
    {
        "Отметка времени": "12\/27\/2023 12:25:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "valeria.kolesnichenko@aquaart.group",
        "to": "IT Управление",
        "wish": "Огромное спасибо любимому IT управлению и прекрасному руководителю - Заречнюку Дмитрию, за постоянную поддержку, отзывчивость,терпение и потрясающую командную работу! Работать с Вами одно удовольствие!)"
    },
    {
        "Отметка времени": "12\/27\/2023 12:27:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "maxim.demin@aquaart.ru",
        "to": "Виктория Гаврилова",
        "wish": "Спасибо за оперативность, содействие в решении вопросов клиентов."
    },
    {
        "Отметка времени": "12\/27\/2023 12:31:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "maxim.demin@aquaart.ru",
        "to": "Алексей Горячев",
        "wish": "Спасибо что по делу, с толком, нацелено."
    },
    {
        "Отметка времени": "12\/27\/2023 12:42:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Никита Гуссар",
        "wish": "За то что взял на себя ответственность руководителя службы ИТ поддержки в этом году.  Не смотря на неполную команду, обеспечивает работу всех ИТ сервисов 24*7. Никита, спасибо огромное!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:43:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Лера Князева",
        "wish": "Лера, спасибо за твой труд. Рада, что могу работать с таким профессионалом как ты"
    },
    {
        "Отметка времени": "12\/27\/2023 12:47:53",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Яна Небывалова",
        "wish": "За постоянные улучшения, за оптимизм, за то что каждым ИТ-обращением видите проблемы конкретных людей и всегда их решаете самым лучшим образом! Яна, спасибо!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:50:25",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Анна Тропина",
        "wish": "Благодарю за внимательность, системность, заботу о каждом пользователе ERP, за то что ни одно обращение не остается без внимание, и конечно же за лидерство во внедрении нового функционала ERP!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:52:20",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Валерия Колесниченко",
        "wish": "Вы самый жизнерадостный человек в подразделении! Спасибо за Вашу энергетику! А еще за самостоятельность, системность и надежную первую линию поддержки ERP!"
    },
    {
        "Отметка времени": "12\/27\/2023 12:54:17",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Михаил Калугин",
        "wish": "Спасибо, что за то что все успеваете, что в Ваших сутках точно больше чем 24 часа , за 100% надежность"
    },
    {
        "Отметка времени": "12\/27\/2023 12:55:01",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Наталия Соловьева",
        "wish": "Натали, спасибо за быстрое реагирование на все наши запросы :)"
    },
    {
        "Отметка времени": "12\/27\/2023 12:55:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "valeria.revchuk@ampm-world.com ",
        "to": "Наталья Новикова",
        "wish": "За то что, в нашем тандеме, взяла на себя функцию спокойствия, и уравновешиваешь мою экспрессивность. И за то, что понимаешь мою коммуникацию и описание ситуаций по средством мЭмов)))"
    },
    {
        "Отметка времени": "12\/27\/2023 12:56:02",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Михаил Новоятлов",
        "wish": "Спасибо Вам за умение разбираться в сложных вопросах! "
    },
    {
        "Отметка времени": "12\/27\/2023 12:58:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Дмитрий Вардугин",
        "wish": "Дмитрий,  Вы самый эффективный программист в команде! За год Вы закрыли задач больше чем все остальные программисты вместе взятые! Спасибо!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:02:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.andrulyanis@ampm-world.com",
        "to": "Оля Дмитриева <3",
        "wish": "Спасибо за терпение и всегда хорошее настроение! Очень приятно, что так плотно работаю именно с тобой <3"
    },
    {
        "Отметка времени": "12\/27\/2023 13:05:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Виталий Гилев",
        "wish": "Виталий, уверен, что все сотрудники управления ИТ меня поддержат, Вы - центр нашей команды, все сложные задачи всегда оказываются у Вас,  аналитики хотят работать только с Вами. Спасибо Вам за ориентацию на команду, за высокий уровень результатов, и еще за интеграции между системами и мультиязычность!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:07:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Евгения Гусева",
        "wish": "Евгения, Вы смогли сделать невозможное! Количество сбоев при обмене между системами сократилось в десятки раз, закрытие периода занимает не больше двух дней, ошибки устраняются моментально! Спасибо!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:10:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Лиана Штембуляк, Ольга Писаревская,    Александр Бородин, Елена Гапон и все ФЭУ",
        "wish": "Коллеги, спасибо Вам за активное участие в проекте ERP!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:11:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Юрий Быковский",
        "wish": "Юрий, спасибо за внедрение интеграции с Деловыми линиями!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:13:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Евгений Шматов, Анастасия Мазурова, вся команда склада!",
        "wish": "Коллеги, спасибо за активное участие в улучшении интеграции ERP и WMS. За большое количество предложений по оптимизации! Очень приятно работать с профессионалами!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:16:12",
        "Баллы": 0,
        "Ваша корпоративная почта": "yuliya.andrulyanis@ampm-world.com",
        "to": "Котятам склада СПб",
        "wish": "Любви и добра в Новом году! Оставайтесь такими же большими и сильными мужчинами, мы Вас очень ценим:)"
    },
    {
        "Отметка времени": "12\/27\/2023 13:16:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "DO",
        "wish": "Спасибо команде DO, особенно Алексею, Светлане, Михаилу, Анастасии, Дарье, за профессионализм, имплементацию новых технологий проектного управления и терпение! \nПриложение MY-AM.PM 2.0 получится очень крутым!\n"
    },
    {
        "Отметка времени": "12\/27\/2023 13:18:32",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Вадим Истратий",
        "wish": "Вадим, спасибо за активную позицию и помощь в интеграции EDI с Леруа! Удачи в продажах в следующем году!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:23:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Службы УТЗ и Логистики",
        "wish": "Коллеги, спасибо за профессионализм ! Как обычно в этом году Вы были неподражаемы,  опережали как минимум на полгода технологии, безошибочно предвидели , точно считали, иногда на счетах, разворачивали поезда и пароходы и многое другое невозможное! Удачи и счастья в следующем году! "
    },
    {
        "Отметка времени": "12\/27\/2023 13:31:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Pavel Foigt",
        "wish": "Павел, спасибо за проактивность и внимательность! А еще за крутую презентацию по факторингу, благодаря Вам решение было найдено на 15 минут, непосредственно во время презентации! Удачи и счастья в следующем году"
    },
    {
        "Отметка времени": "12\/27\/2023 13:33:43",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Анна Минаева",
        "wish": "Анна,   благодаря Вам в этом году бухгалтерия открылась совсем с другой стороны!  Спасибо за то что смело распределяете функционал, беретесь за любые сложные задачи, за проактивность во внедрении ERP!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:39:19",
        "Баллы": 0,
        "Ваша корпоративная почта": "Eelena.sukhacheva@aquaart.ru",
        "to": "Ирина Сотникова",
        "wish": "Иринка! Благодарю тебя за поддержку, за чуткость и доброту . Спасибо тебе за улыбку и  понимание. Твой оптимизм и энергия заряжают все вокруг, дают надежду и силы для решения вопросов. Удачи тебе на жизненном пути и счастья бесконечного."
    },
    {
        "Отметка времени": "12\/27\/2023 13:42:27",
        "Баллы": 0,
        "Ваша корпоративная почта": "dm_zar@aquaart.ru",
        "to": "Наталья Яковенко",
        "wish": "Наталья, спасибо за инициативность и  четкую постановку задач! Благодаря Вам мы смогли увидеть слабые места в процессах, значительно скорректировать функционал ERP системы, настроить эквайринг и факторинг, и все время держим в голове \"что бухгалтерский учет первичен\". Ваш вклад в улучшение финансового учета в компании огромен! Спасибо. Успехов и счастья в следующем году!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:47:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalia.yurkevich@aquaart.ru",
        "to": "IT МСК",
        "wish": "Дорогие коллеги! Спасибо Вам за отзывчивость! Год был непростой, но вы всегда  готовы прийти на помощь! Здоровья, счастья и благополучия в Новом году! "
    },
    {
        "Отметка времени": "12\/27\/2023 13:49:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalia.yurkevich@aquaart.ru",
        "to": "ФЭУ МСК",
        "wish": "Коллеженьки! С наступающим Новым годом! Желаю успехов, благополучия, любви и счастья! Много-много счастливых моментов и радостных улыбок каждый день!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:50:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "natalia.yurkevich@aquaart.ru",
        "to": "IT СПБ",
        "wish": "Коллеги! Спасибо Вам за помощь и поддержку! Желаю правильных ТЗ и ответственных юзеров :)"
    },
    {
        "Отметка времени": "12\/27\/2023 13:50:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "ekaterina.ionova@aquaart.ru",
        "to": "ИТ-Москва",
        "wish": "Хочу выразить благодарность ИТ-Москва! Наши Леши всегда на связи, с ними мы уверены в бесперебойной работе техники и программ! Вы-настоящие профи, находка для компании! Успехов вам в Новом 2024году!!!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:51:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "elena.sukhacheva@aquaart.ru",
        "to": "МПмск",
        "wish": "Девочки мои - Елена Сергеевна , Людмила , Марина, Иринка -  спасибо за вашу помощь и поддержку. Хороший коллектив — залог успеха в рабочих делах. Искренне благодарю каждого из вас за теплоту и доброту, за щедрость и мудрость. С вами не страшны никакие перемены. Удачи вам и процветания!\n\n\n"
    },
    {
        "Отметка времени": "12\/27\/2023 13:53:55",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatiana-klimkina@ampm-world.com",
        "to": "Андрей Величко, Андрей Дергунов",
        "wish": "Спасибо за ваш супер-профессионализм, умение найти решение любой задачи, оперативно и элегантно воплотить его в жизнь, а также за ваш юмор :)  Работать с вами легко, надёжно и приятно. Спасибо вам!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:53:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.mokrousova@ampm-world.com",
        "to": "Татьяна Истомина",
        "wish": "Таня, спасибо за твой труд, быстрое решение задач и классное сотрудничество! Пусть в Новом году сбываются все заветные мечты!"
    },
    {
        "Отметка времени": "12\/27\/2023 13:54:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "Sotnikova Irina <Irina.Sotnikova@aquaart.ru>",
        "to": "МП МСК",
        "wish": "Дорогие девушки, вы -лучшие , умеющие выполнять любые поставленные задачи, вовремя откликающиеся на любые вопросы , поддерживающие в любой жизненной ситуации, пусть Новый год принесет Вам много счастья, радости , любви и благополучия."
    },
    {
        "Отметка времени": "12\/27\/2023 14:04:50",
        "Баллы": 0,
        "Ваша корпоративная почта": "dmitry.saidov@aquaart.ru",
        "to": "Светлана Горшкова",
        "wish": "Светлана, Светлана. Спасибо тебе за то, что тебе не все равно. Светлана всегда выслушает и поддержит тебя в любой сложной ситуации. Всегда с улыбкой, всегда в отличном настроении. Спасибо за эмоциональный заряд."
    },
    {
        "Отметка времени": "12\/27\/2023 14:05:23",
        "Баллы": 0,
        "Ваша корпоративная почта": "dmitry.saidov@aquaart.ru",
        "to": "Александр Татищев",
        "wish": "Знания сила. Благодаря Александру за этот год я узнал множество вещей. Саша Клондайк идей и путей решений сложных моментов. Во времена упадка энергии. Саша Всегда поддержит, поможет и подарит заряд мотивации."
    },
    {
        "Отметка времени": "12\/27\/2023 14:06:00",
        "Баллы": 0,
        "Ваша корпоративная почта": "dmitry.saidov@aquaart.ru",
        "to": "Виталий Курган",
        "wish": "Спасибо за отличный опыт, хорошее настроение и постоянный драйв"
    },
    {
        "Отметка времени": "12\/27\/2023 14:06:07",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatiana-klimkina@ampm-world.com",
        "to": "Елена Гапон",
        "wish": "Лена, спасибо за профессионализм!!! А также за твоё спокойствие и доброжелательность. Ты крутая, с тобой очень приятно работать."
    },
    {
        "Отметка времени": "12\/27\/2023 14:08:57",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatiana-klimkina@ampm-world.com",
        "to": "Елена Смирнова",
        "wish": "Лена, благодарю за профессионализм и оперативность. Работать с тобой легко и приятно."
    },
    {
        "Отметка времени": "12\/27\/2023 14:20:15",
        "Баллы": 0,
        "Ваша корпоративная почта": " Denis.Khlebov@aquaart.ru ",
        "to": "Татьяна Чернышова ",
        "wish": "Смелая, умелая! Ты молодец, никогда не переживаю за твою работу. Если ты взялась за дело - всё будет СУПЕР! be happy!"
    },
    {
        "Отметка времени": "12\/27\/2023 14:29:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "tatiana-klimkina@ampm-world.com",
        "to": "СПП: Эльвира Петрова, Ольга Михайлова",
        "wish": "Спасибо большое за вашу оперативность, отзывчивость, доброжелательность и профессиональную помощь в нелёгком деле приведения АПП к ПП :) "
    },
    {
        "Отметка времени": "12\/27\/2023 14:57:49",
        "Баллы": 0,
        "Ваша корпоративная почта": "egor.ksenafontov@ampm-world.com",
        "to": "Юлия Андрулянис",
        "wish": "Спасибо, что доставляешь не только образцы для всех категорий, но и удовольствие от совместной работы!"
    },
    {
        "Отметка времени": "12\/27\/2023 15:00:46",
        "Баллы": 0,
        "Ваша корпоративная почта": "vasiliy@aquaart.ru",
        "to": "Асель Желтроп",
        "wish": "За личное участие, за ответственное отношение, за развитие онлайн продаж алматинского офиса!"
    },
    {
        "Отметка времени": "12\/27\/2023 15:02:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "vasiliy@aquaart.ru",
        "to": "Павел Пивоваров",
        "wish": "За бесперебойную работу склада и поддержку всех отделов продаж!"
    },
    {
        "Отметка времени": "12\/27\/2023 18:24:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "Dm_zar@aquaart.ru",
        "to": "Яна Фомичева",
        "wish": "Яна, спасибо Вам за внимательность и четкую постановку задач ИТ,  каждый проект с Вашим участием всегда обогащает нас новыми знаниями и подходами! Удачи и счастья в  новом году!"
    },
    {
        "Отметка времени": "12\/27\/2023 18:29:26",
        "Баллы": 0,
        "Ваша корпоративная почта": "Dm_zar@aquaart.ru",
        "to": "Анна Лебедева",
        "wish": "Аня, спасибо Вам за самую лучшую доработку УТ10, за четко работающие обмены с бухгалтерией, за то что всегда готовы брать новые задачи и очень быстро их делаете!"
    },
    {
        "Отметка времени": "12\/27\/2023 20:41:37",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Иоланта Леконцева",
        "wish": "Лана, спасибо, что всегда готова поддержать и помочь в трудной ситуации! вместе мы справляемся с любыми задачами! :)"
    },
    {
        "Отметка времени": "12\/27\/2023 20:46:47",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Валерия Князева",
        "wish": "Лера, спасибо, что делишься своими знаниями и опытом) "
    },
    {
        "Отметка времени": "12\/27\/2023 20:54:28",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Иванова Наталья",
        "wish": "Наташа, спасибо за помощь и поддержку) С тобой любая невыполнимая задача становится выполнимой :)"
    },
    {
        "Отметка времени": "12\/27\/2023 21:02:36",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Борисова Светлана",
        "wish": "Света, ты всегда поддержишь и подбодришь! С тобой работается весело и легко! Спасибо за трудолюбие, помощь и отзывчивость! "
    },
    {
        "Отметка времени": "12\/27\/2023 21:07:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "anna.pankratova@aquaart.ru",
        "to": "Содрудникам склада",
        "wish": "Коллеги, спасибо, что даже в самых сложных и стрессовых ситуациях вы сохраняете свой оптимизм:) Ценим ваш труд! "
    },
    {
        "Отметка времени": "12\/27\/2023 22:53:16",
        "Баллы": 0,
        "Ваша корпоративная почта": "denis.perminov@aquaart.ru",
        "to": "Александр Татищев",
        "wish": "Александр, спасибо за профессионализм, развитие и возможность видеть и открывать новые горизонты."
    },
    {
        "Отметка времени": "12\/28\/2023 8:33:15",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Алла Струк",
        "wish": "Большое спасибо за ваше сладкое пожелание! Ваши добрые слова и любящие мысли каждый  мой день делают веселым и положительным! Оставайтесь всегда такой же позитивной и жизнерадостной! Спасибо вам за каждодневный позитив в нашем коллективе!!"
    },
    {
        "Отметка времени": "12\/28\/2023 8:36:30",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Клейбаум Светлана",
        "wish": "Поздравляю с наступающим Новым годом! Желаю, чтобы каждая минута приносила только радость, каждое событие было приятным и долгожданным, а каждая задумка заканчивалась успешным результатом! Спасибо Вам за Вашу работу и помощь!!\n\n\n"
    },
    {
        "Отметка времени": "12\/28\/2023 8:39:04",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Ахметвалеев Руслан",
        "wish": "Желаю, чтобы следующие двенадцать месяцев были полны профессиональных успехов и замечательных личных событий. Пусть в новом году даже самый обычный день приносит маленький приятный сюрприз, любой гнев перерастает в улыбки, грусть ― в надежду, а любовь и мир сопутствуют всем, кто тебя окружает. Счастливого Нового года! Спасибо Вам за Ваш позитив и хорошее настроение, которое всегда заряжает меня на весь день! \n\n"
    },
    {
        "Отметка времени": "12\/28\/2023 9:11:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "anastasiya.mikhailichenko@aquaart.kz",
        "to": "Мария Калинина",
        "wish": "Мария, спасибо, Вам, большое за помощь, спасибо, что переживаете за нас, за наше АПП и за наличие у нас товара на складе КЗ. Пусть грядущий год станет началом успешного, знаменательного пути, и на каждой остановке будут ждать только приятные сюрпризы и яркие события. Пусть согласие и гармония царят в семье, а работа приносит радость и удовольствие. Пусть в душе бушует молодость, а горячий энтузиазм не дает усидеть на месте. Любите, наслаждайтесь жизнью, познавайте мир и ищите счастье в мелочах."
    },
    {
        "Отметка времени": "12\/28\/2023 10:07:18",
        "Баллы": 0,
        "Ваша корпоративная почта": "sergey.shunkov@aquaart.ru",
        "to": "Анна Хазанова ",
        "wish": "Сочетание лучших качеств - целеустремлённость в достижении результата и при этом открытость для новых идей и новых направлений. Классный баланс креатива и логики, умения выстроить и следовать чёткой структуре и при этом действовать абсолютно без кальки, формул, ориентируясь каким то своим, внутренним чувством гармонии) \n "
    },
    {
        "Отметка времени": "12\/28\/2023 11:22:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "Liliya.lebed@aquaart,ru",
        "to": "Валерия Колесниченко",
        "wish": "Валерия - ты лучшая! Спасибо за оперативную помощь, гуру 1С! "
    },
    {
        "Отметка времени": "12\/28\/2023 11:43:59",
        "Баллы": 0,
        "Ваша корпоративная почта": "evgenii.shmatov@aquaart.ru",
        "to": "Коллегам из УЛиП, УТЗ",
        "wish": "Спасибо всем за командный дух и профессионализм в работе!"
    },
    {
        "Отметка времени": "12\/28\/2023 12:06:42",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Мои птенчики из УЛ",
        "wish": "Дорогие мои ребята, спасибо Вам всем за этот год, мы сражались, боролись, радовались победам, искали решения и находили их, прикрывали друг другу спины и стояли друг за друга горой! я очень вас люблю и хочу, чтобы в Новом Году у вас все сбывалось и в работе, и в личной жизни и просто для себя. Будьте счастливыми, любимыми и здоровыми! Всех обнимаю, без вас бы ничего не вышло. Ваша НБ."
    },
    {
        "Отметка времени": "12\/28\/2023 12:08:24",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Андрей Таскаев",
        "wish": "Андрюша, спасибо тебе за все - за помощь, поддержку, советы, за споры и найденные решения! Пусть Новый Год будет счастливым, и ты тоже будешь счастливым)))) "
    },
    {
        "Отметка времени": "12\/28\/2023 12:56:13",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Леночка Гапон",
        "wish": "Мой милый дружок, я тебя ценю и обожаю, с тобой очень хорошо работать, мы всегда находим решения во всех ситуациях, мы нашли с тобой понимание и так комфортно, как с тобой, я даже не знаю с кем еще так работается. Пусть у тебя будет очень счастливый, хороший, удачный и легкий Новый Год))) обнимаю. "
    },
    {
        "Отметка времени": "12\/28\/2023 12:58:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Анастасия Верещагина",
        "wish": "Настя! Вы моя надежда и опора, спасибо что рядом и что так достойно несете все свои многочисленные обязанности) Вы профессионал и я очень рада, что когда-то поставила именно на Вас)) да пребудет с Вами сила)) Счастья, любви и успехов в Новом Году! "
    },
    {
        "Отметка времени": "12\/28\/2023 13:00:21",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Леонид Матвеевич",
        "wish": "Спасибо за то, что даете возможность постоянно расти, развиваться и приходить к выводу, что для нас нет ничего невозможного, даже если сначала я в этом уверена))) "
    },
    {
        "Отметка времени": "12\/28\/2023 13:18:41",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "УТЗ-шечке",
        "wish": "Дорогие коллеги! Спасибо, что мы с Вами всегда рядом, всегда в связке, всегда готовы помочь друг другу! И даже наши совещания каждую неделю, иногда по 2 часа, мы часто можем превратить во что-то жизнерадостное)) спасибо каждому из Вас за вашу сложную и такую нужную работу. Вы все классные! Счастливого Нового Года и сговорчивых поставщиков! "
    },
    {
        "Отметка времени": "12\/28\/2023 13:21:45",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Юлия Андрулянис",
        "wish": "Юлечка! Спасибо тебе за этот год, ты многому научилась, ты очень ценная для УЛ и для всей компании! Спасибо, что последние 2 месяца ты просто каждый день спасала всех нас! Продажи, Склад, УТК -все под твоим крылом))) Будь очень счастлива в Новом Году! Сил, терпения, радости и любви! "
    },
    {
        "Отметка времени": "12\/28\/2023 13:31:52",
        "Баллы": 0,
        "Ваша корпоративная почта": "Natalia.Barleeva@ampm-world.com",
        "to": "Екатерина Ермакова",
        "wish": "Спасибо за помощь, поддержку,  такие нужные советы и простое человеческое отношение! Так важно знать, что ты не один, и просто есть Катя, которая взяла и встала рядом в критический момент. И вот ты уже просто идешь делать то, что можешь и должен) В этом сила твоего профессионализма и большого управленческого опыта. В этом суть команды, в этом суть всего, что мы тут делаем и за что боремся.   Спасибо много-много раз! Спасибо за Ваш труд в формировании команды, люди - это, наверное, самая важная и сложная часть нашей работы. И вы справляетесь даже в таких сложных условиях. Катя, ты и вся твоя команда - очень классные! Большого счастья, любви и успехов в Новом Году! "
    },
    {
        "Отметка времени": "12\/28\/2023 13:37:10",
        "Баллы": 0,
        "Ваша корпоративная почта": "valeria.kolesnichenko@aquaart.group",
        "to": "Дмитрий Заречнюк",
        "wish": "\n\nСпасибо за возможность работать с Вами, под Вашим мудрым и чутким руководством, с Вами не страшно и интересно решать любые задачи! Спасибо за понимание! Море успехов Вам в Новом году!"
    },
    {
        "Отметка времени": "12\/28\/2023 14:13:48",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.danilkina@aquaart.ru",
        "to": "Михальчук Татьяна Викторовна",
        "wish": "Вы-начальник мировой!\nС умной, светлой головой,\nК Вам большое уваженье,\nВы - пример для подражанья\nДобрый Вы, трудолюбив,\nЛюбите наш коллектив.\nПомогаете решить:\nГде? Зачем? Куда идтить!? \nНе угрюмый и не злой\nНаш начальник дорогой!\nС наступающим 2024 годом поздравляем!\nМП мск:)\n\n\n"
    },
    {
        "Отметка времени": "12\/28\/2023 14:14:31",
        "Баллы": 0,
        "Ваша корпоративная почта": "nadezhda.belyaeva@ampm-world.com",
        "to": "Николай Плотник",
        "wish": "Спасибо за дружественную атмосферу в коллективе !!!"
    },
    {
        "Отметка времени": "12\/28\/2023 14:15:40",
        "Баллы": 0,
        "Ваша корпоративная почта": "nadezhda.belyaeva@ampm-world.com",
        "to": "Светлана Носикова",
        "wish": "Светик, спасибо за то, что ты есть в этой компании !!! За твою улыбку, позитив и отзывчивость !!!"
    },
    {
        "Отметка времени": "12\/28\/2023 14:21:39",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.danilkina@aquaart.ru",
        "to": "Пивоваров Павел",
        "wish": "Уважаемый спортсмен,\nНаш спортивный супермен,\nНовых подвигов желаем,\nДостижений и побед.\nВместе на Луну слетаем \nМы с сантехникой иль без!\nМП мск:)\n"
    },
    {
        "Отметка времени": "12\/28\/2023 15:12:44",
        "Баллы": 0,
        "Ваша корпоративная почта": "assel.zheltrop@aquaart.kz",
        "to": "ИМ Казахстан",
        "wish": "Спасибо за крутые результаты по продажам! За сплоченную, дружную команду! Только вперед!"
    },
    {
        "Отметка времени": "12\/28\/2023 15:34:51",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.danilkina@aquaart.ru",
        "to": "СКС_мск",
        "wish": "Пусть несет вам Новый год\nПроцветанье и доход.\nПусть сопутствует успех,\nЧтоб ни в чем не знать помех.\nПусть здоровье будет крепким,\nУм же - просветленным, крепким,\nВ мире - мир, а в семьях - лад.\nПОВЫШЕНЬЯ ВСЕМ ЗАРПЛАТ!!!!\nС Наступающим Новым 2024 годом! \nОтдел МП_мск\n\n"
    },
    {
        "Отметка времени": "12\/28\/2023 15:35:08",
        "Баллы": 0,
        "Ваша корпоративная почта": "Irina Sotnikova' <irina.sotnikova@aquaart.ru>",
        "to": "Елена Сухачева",
        "wish": "Дорогая Леночка- ты светлый  и прекрасный человек в нашей компании, хочу поблагодарить  тебя за поддержку, неравнодушие, понимание, доброту и отзывчивость. Успехов тебе в Новом году!"
    },
    {
        "Отметка времени": "12\/28\/2023 17:58:14",
        "Баллы": 0,
        "Ваша корпоративная почта": "evgeniya.gorpinchenko@aquaart.ru",
        "to": "Девочкам с Маркетплейса (СКЛАД)",
        "wish": "Кошечки!!!!Пусть весь следующий год  пройдет так:\nЛегко, без забот, будет полон он счастья,\nЛюбовь принесет!\nЖелаем: Оптимизма, детского восторга!\nСмелости под елкой танцевать!\nПусть продлится праздник долго-долго,\nЧтоб весь год хотелось вспоминать!\nP.S.  Оставайтесь такими же прекрасными, позитивными и энергичными.\n"
    },
    {
        "Отметка времени": "12\/29\/2023 9:18:22",
        "Баллы": 0,
        "Ваша корпоративная почта": "marina.danilkina@aquaart.ru",
        "to": "Михальчук Татьяна Викторовна",
        "wish": "Выражаю благодарность за организацию рабочего процесса в отделе СКС_мск. \nХочу выразить Вам искреннюю признательность за продуктивный совместный труд, помощь и содействие в решении затруднительных вопросов, дружеское участие и сопереживание, гармоничное общение.\nС Наступающим 2024 годом! с уважением отдел МП_мск.\n\n"
    }
];
export const shortWishesMock = [
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
    {
        to: "Отдел DO",
        wish: "Желаю счастья и здоровья!!!!!"
    },
]